/*
 * Labor Teaser im Vollbild (sections/zl-teaser-labor.liquid). Sechs Richtungen für den ersten Bildschirm, Regler unten rechts.
 * Auf ?view=zl-start steuert derselbe Regler auch, was darunter kommt (sections/zl-start-darunter.liquid).
 * Werte bleiben in diesem Browser gespeichert, "Werte kopieren" gibt sie als Text weiter.
 * Der Stand steht in der Adresse (#r=5&schleier=0.14, assets/zl-stand.js), jeder Zustand ist ein Link; #r1 bis #r6 allein öffnet eine Richtung. Nichts läuft von selbst, außer der Timer
 * der Geschichten wird im Regler eingeschaltet. Bei "Bewegung reduzieren" steht alles still.
 */
(() => {
  const root = document.querySelector('[data-zl-tl]');
  if (!root) return;
  const html = document.documentElement;
  let schriftDa = false; /* beide Schnitte der Schrift geladen: erst dann steht fest, wo Text endet */
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

  const KEY = 'zl-teaser-labor-1';
  const START = {
    r: '1', bild: 'a', lage: 'block', ort: 'block', etikett: 'an', preis: 'an', tiefe: 0.35, timer: 'aus', timerS: 6, blende: 'an', chips: 'an',
    showBild: 'folie', knopf: 'text', segmente: 'unten', steuerung: 'leiste', paket: 'heute', geschenke: 'leiste', nameWahl: '1', zeileWahl: '1', adventZeile: '1', awardsD: 'etiketten', paketHandy: 'flaschen', paketHandyCh: 'foto', paketDesktop: 'nah', wheatAuftritt: 'schweben', anschnitt: 'etikett', leiste: 'aus', spaeter: 'an', gHandy: 'schleier-ganz', schleier: 0.2, fb: {}, lauf: 'an', ende: 'schleife', besuch: 'echt', tickerLauf: 'an',
    hoehe: 'm', blockLage: 'achse', schrift: 'handy36', kapitelwort: 'gross', zahl: 'beleg', grund: 'an', aw: 'wand', darunter: 'shop', bewertungen: 'neu', bwAuftritt: 'an', bekanntAus: 'kapitel', baTitel: 'spricht', bekanntMarke: 'logo', achse: 'kante', textWechsel: 'vor', bildWechsel: 'gleiten', kauf: 'an', bekannt: 'zeile', haltung: '1', sortenTitel: '1', paketTitel: '1', zucker0: 'an', licht: 0.16, dunkel: 0.7,
  };
  /* Live (data-live): keine gespeicherten Reglerwerte, es gilt die feste Fassung, und nichts wird gespeichert */
  const live = root.hasAttribute('data-live');
  const load = () => { if (live) return {}; try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } };
  /* Der Stand steht auch in der Adresse (assets/zl-stand.js): nur die Felder, die von der Grundlage abweichen */
  let grundlage = START;
  const save = () => {
    if (live) return;
    try { localStorage.setItem(KEY, JSON.stringify(S)); } catch (e) { /* ohne Speicher geht es auch */ }
    if (window.zlStand) window.zlStand.schreiben(S, grundlage);
  };
  const S = { ...START, ...load() };
  // Stand 2: Button schmal unter dem Text ist neu der Standard, auch für gespeicherte Werte
  if ((S.v || 1) < 2) { S.knopf = 'text'; S.v = 2; }
  // Stand 3: Geschenke als graue Leiste, Bild je Folie statt eines Bilds für alle
  if (S.v < 3) { S.geschenke = 'leiste'; S.fb = {}; S.v = 3; }
  // Stand 4: Nach der letzten Folie beginnt die Show von vorn (Moritz, 11.10.2026)
  if (S.v < 4) { S.ende = 'schleife'; S.v = 4; }
  // Stand 5: ein Grauschleier liegt gleichmäßig über dem ganzen Bild (Moritz, 11.10.2026)
  if (S.v < 5) { S.gHandy = 'schleier-ganz'; S.v = 5; }
  // Stand 6: die Kante schneidet die Flasche genau am unteren Rand des Etiketts (Moritz, 11.10.2026)
  if (S.v < 6) { S.anschnitt = 'etikett'; S.v = 6; }
  // Stand 7: Grauschleier schwächer, das Bild bleibt farbig (Moritz, 11.10.2026)
  if (S.v < 7) { S.schleier = 0.2; S.v = 7; }
  // Stand 8: keine Bilder mehr je Folie aus dem Regler, es gilt, was die Kampagne vorgibt
  if (S.v < 8) { S.fb = {}; S.v = 8; }
  // Stand 9: Überschrift der Blöcke am Handy 36 statt 28 (Moritz, 19.10.2026)
  if (S.v < 9) { S.schrift = 'handy36'; S.v = 9; }
  // Stand 10: Kapitelwort als kleine Überschrift, Handy 20, Desktop 24 (Moritz, 19.10.2026)
  if (S.v < 10) { S.kapitelwort = 'gross'; S.v = 10; }
  // Stand 11: Zahl wie eine Kennzahl, ohne Kapitelwort, darunter „Biere verkauft.“ (Moritz, 19.10.2026)
  if (S.v < 11) { S.zahl = 'beleg'; S.v = 11; }
  // Stand 12: „desktop“ heißt seit der Übernahme auf alle Seiten dasselbe wie handy36 (19.10.2026)
  if (S.v < 12) { if (S.schrift === 'desktop') S.schrift = 'handy36'; S.v = 12; }
  /* Entschieden (Moritz, 11.10.2026): Auf ?view=zl-start gilt für alles außer dem Auftritt von Easy Wheat die feste Fassung,
     egal was in diesem Browser gespeichert ist. Die Kampagne für später (Adventskalender) zeigt die Vorschau mit ?zl-kalender. */
  const FEST = { wheatAuftritt: 'drehen', paket: 'heute', paketDesktop: 'nah', paketHandy: 'flaschen', paketHandyCh: 'foto', nameWahl: '1', zeileWahl: '1', adventZeile: '1', awardsD: 'etiketten', schleier: 0.14, leiste: 'aus', spaeter: 'aus', bekanntAus: 'kapitel', bekanntMarke: 'name', achse: 'kante', fb: {}, knopf: 'text', geschenke: 'leiste', segmente: 'unten', steuerung: 'leiste', lauf: 'an', timerS: 6, ende: 'schleife', blende: 'an', besuch: 'aus', gHandy: 'schleier-ganz', anschnitt: 'etikett', etikett: 'an', preis: 'an' };
  if (!S.fb || typeof S.fb !== 'object') S.fb = {};
  if (S.gHandy === 'band') S.gHandy = 'schleier-verlauf';
  const darunterDa = !!document.querySelector('[data-zl-du]');
  // Auf ?view=zl-start steht nur die Show, die anderen Richtungen gibt es auf ?view=zl-teaser
  const nurShow = root.hasAttribute('data-nur-show');
  // Nur im Labor (?view=zl-start, ?view=zl-teaser): Vorschläge, die noch nicht entschieden sind. Außerhalb gilt die entschiedene Fassung.
  const imLabor = root.hasAttribute('data-labor');
  if (darunterDa && !load().r) S.r = '5';
  /* Werte aus der Adresse (#r=5&schleier=0.14, oder #r5) gehen vor dem Gespeicherten */
  const ausAdresse = !live && window.zlStand ? window.zlStand.lesen(START) : {};
  if (ausAdresse.r && !/^[1-6]$/.test(ausAdresse.r)) delete ausAdresse.r;
  Object.assign(S, ausAdresse);
  if (!live && /[?&]zl-bw=neu/.test(location.search)) { S.bewertungen = 'neu'; save(); }
  { const m = !live && location.search.match(/[?&]zl-ba=(heute|satz|kapitel|zeile|stimmen|deckel)/); if (m) { S.bekanntAus = m[1]; save(); } }
  { const m = !live && location.search.match(/[?&]zl-achse=(kante|mitte)/); if (m) { S.achse = m[1]; save(); } }
  { const m = !live && location.search.match(/[?&]zl-grund=(an|aus|vorher)/); if (m) { S.grund = m[1]; save(); } } // Startseite: Töne der Flächen, wie entschieden, ohne Flächen oder wie vorher (Zahl und Presse auf zeroWhite)
  { const m = !live && location.search.match(/[?&]zl-aw=(wand|metall|etiketten|farben|pink|weiss)/); if (m) { S.aw = m[1]; save(); } } // Startseite: Grafik der Awards
  { const m = !live && location.search.match(/[?&]zl-hoehe=(aus|s|m|l)/); if (m) { S.hoehe = m[1]; save(); } } // Startseite: feste Höhen der Flächen
  { const m = !live && location.search.match(/[?&]zl-lage=(oben|mitte|achse)/); if (m) { S.blockLage = m[1]; save(); } } // Startseite: Inhalt in der Fläche
  { const m = !live && location.search.match(/[?&]zl-schrift=(heute|alt28|handy36|beide)/); if (m) { S.schrift = m[1]; save(); } } // Startseite: Schrift der Blöcke
  if (!live && /[?&]zl-bw=heute/.test(location.search)) { S.bewertungen = 'heute'; save(); }
  if (nurShow) { S.r = '5'; Object.assign(S, FEST); if (!live && /[?&]zl-kalender/.test(location.search)) S.spaeter = 'an'; grundlage = { ...START, ...FEST, r: '5' }; }
  if (Object.keys(ausAdresse).length) save();

  /* Labor Zahl (19.10.2026): Als Kennzahl fällt das Kapitelwort weg, unter der Zahl steht „Biere verkauft.“. Der Text der Einstellung bleibt im HTML, das Labor tauscht ihn nur zum Vergleich. */
  const zahlText = () => {
    const z = document.querySelector('[data-zl-zahl]'); if (!z) return;
    const nach = z.querySelector('.zl-zahl__nach-a'); if (!nach) return;
    if (!nach.dataset.original) { nach.dataset.original = nach.textContent; z.dataset.labelOriginal = z.getAttribute('aria-label') || ''; }
    const beleg = (S.zahl || 'beleg') !== 'heute';
    nach.textContent = beleg ? 'Biere verkauft.' : nach.dataset.original;
    const vor = (z.querySelector('.zl-zahl__klein:not(.zl-zahl__nach)') || {}).textContent || '';
    const zahl = (z.querySelector('.zl-zahl__zahl') || {}).textContent || '';
    z.setAttribute('aria-label', beleg ? `${vor} ${zahl.slice(0, -1)} Biere verkauft.`.trim() : z.dataset.labelOriginal);
  };

  const NAMEN = { 1: 'Stapel', 2: 'Bühne', 3: 'Geschichten', 4: 'Ein Held', 5: 'Show', 6: 'Ein Satz' };
  const FELDER = {
    alle: [
      { gruppe: 'Für alle' },
      { key: 'bild', label: 'Bilder', typ: 'wahl', optionen: [['a', 'A Ruhig'], ['b', 'B Mit Leben'], ['c', 'C Ganz nah'], ['d', 'D Ausstellung']], nur: ['1', '3', '4'] },
      { key: 'lage', label: 'Foto', typ: 'wahl', optionen: [['block', 'Je Kampagne'], ['tief', 'Unten, Text darüber'], ['voll', 'Ganze Fläche']], nur: ['1', '3', '4'] },
      { key: 'etikett', label: 'Etikett (Neu, Rabatt)', typ: 'wahl', optionen: [['an', 'Zeigen'], ['aus', 'Weglassen']] },
      { key: 'preis', label: 'Preis beim Paket', typ: 'wahl', optionen: [['an', 'Zeigen'], ['aus', 'Weglassen']] },
    ],
    1: [
      { gruppe: 'Stapel' },
      { key: 'ort', label: 'Text', typ: 'wahl', optionen: [['block', 'Je Kampagne'], ['oben', 'Immer oben'], ['unten', 'Immer unten']] },
    ],
    2: [
      { gruppe: 'Bühne' },
      { key: 'tiefe', label: 'Flasche läuft beim Wischen langsamer', min: 0, max: 0.8, step: 0.05, prozent: true, stufen: [[0, 'gleich schnell']] },
    ],
    3: [
      { gruppe: 'Geschichten' },
      { key: 'timer', label: 'Weiter von selbst', typ: 'wahl', optionen: [['aus', 'Nein, nur Tippen'], ['an', 'Ja, mit Zeit']] },
      { key: 'timerS', label: 'Zeit je Bild', min: 3, max: 12, step: 0.5, einheit: ' s' },
      { key: 'blende', label: 'Wechsel', typ: 'wahl', optionen: [['an', 'Weich überblenden'], ['aus', 'Schnitt']] },
      { hinweis: 'Rechts tippen: weiter. Links tippen: zurück. Wischen geht auch.' },
    ],
    5: [
      { gruppe: 'Flächen der Startseite', nurStart: true },
      { key: 'hoehe', label: 'Höhe jeder Fläche', typ: 'wahl', nurStart: true, optionen: [['aus', 'Nach dem Inhalt (heute)'], ['s', 'Fest, niedrig: Handy 576, Desktop 720'], ['m', 'Fest, mittel: Handy 648, Desktop 840 (Vorschlag)'], ['l', 'Fest, hoch: Handy 720, Desktop 960']] },
      { key: 'schrift', label: 'Schrift der Blöcke', typ: 'wahl', nurStart: true, optionen: [['handy36', 'Überschrift am Handy 36, Desktop 56 (entschieden 19.10.)'], ['alt28', 'Wie bis 19.10.: Handy 28, Desktop 56'], ['heute', 'Wie früher: Überschrift 28 / 36, Satz 16'], ['beide', 'Handy 40, Satz 20']] },
      { key: 'kapitelwort', label: 'Kapitelwort', typ: 'wahl', nurStart: true, optionen: [['gross', 'Kleine Überschrift: Handy 20, Desktop 24 (entschieden 19.10.)'], ['heute', 'Wie bis 19.10.: Handy 13, Desktop 16']] },
      { key: 'zahl', label: 'Zahl', typ: 'wahl', nurStart: true, optionen: [['beleg', 'Wie eine Kennzahl: Über, Zahl, Biere verkauft. Worte 20 / 24 (gilt, Größe offen)'], ['beleg-gross', 'Über, Zahl, Biere verkauft. Worte als Überschrift 36 / 56'], ['heute', 'Wie bis 19.10.: Verkauft, Über, Zahl, Biere.']] },
      { key: 'blockLage', label: 'Inhalt in der Fläche', typ: 'wahl', nurStart: true, optionen: [['achse', 'Auf der Mittelachse, oben und unten gleich viel Luft (entschieden)'], ['mitte', 'Senkrecht in der Mitte, an der Kante'], ['oben', 'Text oben, Bild unten, an der Kante']] },
      { key: 'grund', label: 'Töne', typ: 'wahl', nurStart: true, optionen: [['an', 'Sorten und Bewertungen zeroWhite, Zahl und Presse Weiß'], ['vorher', 'Zahl und Presse zeroWhite (vorher)'], ['aus', 'Ohne Flächen']] },
      { key: 'aw', label: 'Grafik der Awards', typ: 'wahl', nurStart: true, optionen: [['wand', 'Alle sieben Siegel (Vorschlag)'], ['metall', 'Siegel in Metall, groß'], ['etiketten', 'Die drei Etiketten mit Medaillen'], ['farben', 'Siegel vor den Etikettfarben'], ['pink', 'Bühne in MunichPink'], ['weiss', 'Siegel in Weiß (vorher)']] },
      { gruppe: 'Bekannt aus' },
      { key: 'achse', label: 'Achse unter dem ersten Bildschirm', typ: 'wahl', optionen: [['kante', 'An der Kante des Logos, wie die Bewertungen'], ['mitte', 'Zahl und Bekannt aus mittig (wie heute)']] },
      { key: 'bekanntAus', label: 'Darstellung', typ: 'wahl', optionen: [['heute', 'Wie heute (Logos der Sektion)'], ['satz', 'Ein Satz unter der Zahl, Medien als Links'], ['kapitel', 'Kapitel: große Überschrift, der Satz, Link zur Presseseite'], ['zeile', 'Eine Zeile unter der Zahl'], ['stimmen', 'Stimmen: Absender wählen, darunter der Bericht'], ['deckel', 'Bierdeckel zum Umdrehen']] },
      { key: 'baTitel', label: 'Überschrift (nur Kapitel)', typ: 'wahl', optionen: [['spricht', 'Darüber spricht man.'], ['gelesen', 'Schon gelesen?'], ['aufgefallen', 'Aufgefallen.'], ['gedruckt', 'Gedruckt, gesendet, getrunken.'], ['nuechtern', 'Die Presse war nüchtern. Wir auch.']] },
      { key: 'bekanntMarke', label: 'Absender', typ: 'wahl', optionen: [['logo', 'Originallogo, wo erlaubt'], ['name', 'Immer Schriftzug']] },
      { gruppe: 'Bewertungen' },
      { key: 'bewertungen', label: 'Darstellung', typ: 'wahl', optionen: [['heute', 'Wie heute (Karussell von Judge.me)'], ['neu', 'Reihe zum Wischen (live)']] },
      { key: 'bwAuftritt', label: 'Auftritt (nach Wechsel neu laden)', typ: 'wahl', optionen: [['an', 'Kopf und Karten treten einmal auf (live)'], ['aus', 'Alles steht (vorher)']] },
      { gruppe: 'Show' },
      { key: 'bildWechsel', label: 'Bild beim Wechsel', typ: 'wahl', optionen: [['gleiten', 'Gleitet: die Folien schieben sich zur Seite, die Schrift eilt voraus (live)'], ['blenden', 'Blendet: die neue Folie legt sich über die alte']] },
      { key: 'textWechsel', label: 'Text beim Wechsel', typ: 'wahl', optionen: [['vor', 'Eilt vor: kommt aus der Richtung des Wechsels, schneller als das Bild, folgt dem Finger'], ['steht', 'Blendet mit dem Bild (vorher)']] },
      { key: 'wheatAuftritt', label: 'Easy Wheat', typ: 'wahl', optionen: [['schweben', 'Die Flasche schwebt von unten herein'], ['drehen', 'Die Flasche dreht sich einmal herein, Etikett rundum'], ['ohne', 'Sie steht schon da']] },
    ],
    6: [
      { gruppe: 'Ein Satz' },
      { key: 'tickerLauf', label: 'Zeile unten', typ: 'wahl', optionen: [['an', 'Wechselt nach Zeit'], ['aus', 'Steht']] },
      { key: 'timerS', label: 'Zeit je Zeile', min: 3, max: 12, step: 0.5, einheit: ' s' },
    ],
    darunter: [
      { gruppe: 'Darunter' },
      { key: 'darunter', label: 'Richtung', typ: 'wahl', optionen: [['shop', '1 Der Shop auf einer Seite'], ['zero', '2 Zero, das schmeckt'], ['tisch', '3 Der Tisch'], ['zahlen', '4 Fünf Zahlen'], ['nichts', 'Nichts']] },
      { key: 'kauf', label: 'Kaufen in der Kachel', typ: 'wahl', optionen: [['an', 'Ja'], ['aus', 'Nein, nur Link']], nur_du: ['shop'] },
      { key: 'haltung', label: 'Satz der Haltung', typ: 'wahl', optionen: [['1', 'Zero, das schmeckt.'], ['2', 'Alles drin. Außer Alkohol.'], ['3', 'Bier. Nur ohne.'], ['4', 'Nie wieder: Ich fahr heute.']], nur_du: ['zero'] },
      { key: 'sortenTitel', label: 'Überschrift Sorten', typ: 'wahl', optionen: [['1', 'Fünf Sorten. Eine Flasche.'], ['2', 'Welche bist du?'], ['3', 'Sortiert nach Durst.'], ['4', 'Unsere Range.']], nur_du: ['shop', 'zero'] },
      { key: 'paketTitel', label: 'Überschrift Paket', typ: 'wahl', optionen: [['1', 'Erst probieren. Dann wissen.'], ['2', '24 Flaschen, vier Antworten.'], ['3', 'Das Paket für den ersten Schluck.'], ['4', 'Jetzt sparen.']], nur_du: ['shop', 'zero', 'tisch'] },
      { key: 'licht', label: 'Lichtstreifen, Breite', min: 0.08, max: 0.6, step: 0.01, prozent: true, nur_du: ['tisch'] },
      { key: 'dunkel', label: 'Halbdunkel', min: 0.2, max: 0.85, step: 0.01, prozent: true, nur_du: ['tisch'] },
      { key: 'zucker0', label: 'Zahl 0 für Zucker', typ: 'wahl', optionen: [['an', 'Zeigen (Freigabe offen)'], ['aus', 'Weglassen']], nur_du: ['zero', 'zahlen'] },
      { key: 'bekannt', label: 'Bekannt aus', typ: 'wahl', optionen: [['zeile', 'Eine Zeile'], ['aus', 'Weglassen']] },
    ],
    4: [
      { gruppe: 'Ein Held' },
      { key: 'ort', label: 'Text', typ: 'wahl', optionen: [['block', 'Wie eingestellt'], ['oben', 'Oben'], ['unten', 'Unten']] },
      { key: 'chips', label: 'Andere Kampagnen klein unten', typ: 'wahl', optionen: [['an', 'Zeigen'], ['aus', 'Weglassen']] },
    ],
  };

  /* ---------- Kopf durchsichtig über dem Bild ---------- */
  const kopf = document.querySelector('.header-wrapper');
  const kopfHoehe = () => (kopf ? kopf.getBoundingClientRect().height : 0);
  /* Der Kopf liegt immer über dem Teaser und bleibt beim Scrollen oben stehen (zl-teaser-labor.css). Durchsichtig ist er
     nur ganz oben, sobald gescrollt wird, ist er weiß, damit kein Text unter Logo und Menü durchläuft. Wie unter dem
     Teaser der Startseite (assets/zl-teaser.js). */
  if (kopf) { kopf.classList.add('header-wrapper--overlay'); html.classList.add('zl-tl-seite'); }
  function kopfStellen() {
    if (!kopf) return;
    const ueberTeaser = window.scrollY <= 2; // token-ok: wie unter dem Teaser der Startseite
    html.classList.toggle('zl-tl-oben', ueberTeaser);
    html.classList.toggle('zlk-kopf-klar', ueberTeaser); /* Kopf durchsichtig: das Menü am Handy fährt hinter ihm durch (zl-kopf.css) */
    let hell = false;
    if (ueberTeaser) {
      let el = null;
      if (S.r === '3') el = root.querySelector('[data-tl-geschichte].is-aktiv');
      else if (S.r === '5') el = root.querySelector('[data-tl-folie5].is-aktiv');
      else if (S.r === '6') el = root.querySelector('.zl-tl-satz [data-tl-k]');
      else if (S.r === '1' || S.r === '4') {
        const y = kopfHoehe() / 2;
        el = [...root.querySelectorAll(`.zl-tl-r[data-r="${S.r}"] [data-tl-kampagne]`)].find((k) => { const r = k.getBoundingClientRect(); return r.top <= y && r.bottom > y; });
      }
      if (el) hell = el.dataset.ton ? el.dataset.ton === 'dunkel' : (el.dataset.bild === 'b' ? el.dataset.kopfB : el.dataset.kopf) === 'true';
    }
    kopf.classList.toggle('is-light', hell);
    html.classList.toggle('zl-tl-kopf-hell', hell);
  }
  function kopfMessen() {
    root.style.setProperty('--tl-kopf', Math.round(kopfHoehe()) + 'px');
    // Text neben dem Foto beginnt an der linken Kante des Logos
    const logo = document.querySelector('.header-wrapper .zl-logo');
    const links = logo ? logo.getBoundingClientRect().left : 0;
    if (links > 0) { root.style.setProperty('--tl-kante', Math.round(links) + 'px'); html.style.setProperty('--tl-kante', Math.round(links) + 'px'); }
    else { root.style.removeProperty('--tl-kante'); html.style.removeProperty('--tl-kante'); }
  }

  /* ---------- Foto tief oder über die ganze Fläche ---------- */
  const desktop = window.matchMedia('(min-width: 769px)'); // token-ok: Desktop-Grenze des Themes
  function namenEinpassen() {
    // Ein langes Wort wird kleiner, statt über den Rand zu laufen
    root.querySelectorAll('.zl-tl-name').forEach((n) => {
      n.style.removeProperty('--tl-name-fit');
      const box = n.parentElement;
      if (!n.offsetWidth || !box) return;
      const cs = getComputedStyle(box);
      const platz = box.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      if (n.scrollWidth <= platz) return;
      const fs = parseFloat(getComputedStyle(n).fontSize);
      n.style.setProperty('--tl-name-fit', Math.floor(fs * platz / n.scrollWidth) + 'px');
    });
  }
  // Hell oder dunkel: gemessen am Rand des Fotos, der die Fläche hinter dem Text bildet (Handy oben, Desktop links)
  const toene = {};
  const bildVon = (el) => el.querySelector({ b: '.zl-tl-bild__b', g: '.zl-tl-bild__g' }[el.dataset.bild] || '.zl-tl-bild__a') || el.querySelector('.zl-tl-bild__a');
  function tonMessen(el, seite, fertig) {
    const img = bildVon(el);
    if (!img) return;
    const src = (img.currentSrc || img.src).replace(/width=\d+/, 'width=64');
    seite = seite || (desktop.matches ? 'links' : 'oben');
    const key = src + seite;
    const setzen = fertig || ((t) => { el.dataset.ton = t; kopfStellen(); });
    if (toene[key]) { setzen(toene[key]); return; }
    const bild = new Image();
    bild.crossOrigin = 'anonymous';
    bild.onload = () => {
      try {
        const c = document.createElement('canvas');
        const n = 32;
        c.width = n; c.height = n;
        const x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(bild, 0, 0, n, n);
        const d = seite === 'oben' ? x.getImageData(0, 0, n, 3).data : seite === 'unten' ? x.getImageData(0, n - 3, n, 3).data : x.getImageData(0, 0, 3, n).data;
        let l = 0;
        for (let i = 0; i < d.length; i += 4) l += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2];
        toene[key] = l / (d.length / 4) < 140 ? 'dunkel' : 'hell';
        setzen(toene[key]);
      } catch (e) { /* ohne Messung gilt die Einstellung der Kampagne */ }
    };
    bild.src = src;
  }
  // Ton an der unteren Kante, dort stehen die Segmente der Show: Grafik nach ihrem Grund, Foto gemessen
  function untenMessen(el) {
    if (!el.matches('[data-tl-folie5]')) return;
    const fertig = (t) => { el.dataset.tonUnten = t; if (el.classList.contains('is-aktiv')) segStellen(); };
    if (el.dataset.lage === 'grafik') fertig(el.dataset.grund === 'zeroblack' || el.dataset.farbe === 'hell' ? 'dunkel' : 'hell');
    else if (el.dataset.lage === 'voll' && el.dataset.bild !== 'g') fertig((el.dataset.bild === 'b' ? el.dataset.farbeB : el.dataset.farbe) === 'hell' ? 'dunkel' : 'hell');
    else tonMessen(el, 'unten', fertig);
  }
  /* ---------- Easy Wheat dreht sich herein (Regler „Easy Wheat“: drehen) ----------
     Glas und Etikett rundum aus assets/zl-flasche.js, wie auf den Produktseiten. Die Fläche liegt genau über dem Bild der
     Flasche: gleich breit im Glas, die Unterkante des Etiketts auf derselben Höhe, damit der Anschnitt am Etikett bleibt.
     Packshot 480 x 1384, Glas 92,1 % breit, Etikett endet bei 85,77 %. Bild der Show: Glas 96,5 % breit, Etikett endet bei
     85,82 %. Bis Glas und Etikett geladen sind, steht das Bild. */
  const glasHuelle = root.querySelector('[data-tl-glas]');
  const glasFolie = glasHuelle && glasHuelle.closest('[data-tl-folie5]');
  let glas = null, glasLaedt = null, glasLauf = 0, glasWarAktiv = false;
  const GLAS_BREITE = (1061 / 1100) / (442 / 480), GLAS_HOEHE = GLAS_BREITE * (1384 / 480) / (3385 / 1100); // token-ok: Maße aus den Bildern, siehe oben
  /* Das Etikett aus den Druckdaten endet am Rand weich: Die Flasche steht um --zl-tl-glas-tiefer (Anteil der Bildhöhe)
     tiefer, damit die Kante der Show sie sicher im Etikett schneidet und nie Glas darunter zu sehen ist. */
  const GLAS_OBEN = 0.8582 - 0.8577 * GLAS_HOEHE; // token-ok: Unterkante des Etiketts in beiden Bildern
  const zeitMs = (name) => { const roh = getComputedStyle(html).getPropertyValue(name).trim(); return (/\ds$/.test(roh) && !/ms$/.test(roh) ? parseFloat(roh) * 1000 : parseFloat(roh)) || 0; };
  const glasStart = () => -Math.PI * 2 * (parseFloat(getComputedStyle(html).getPropertyValue('--zl-tl-glas-umdrehung')) || 1); // token-ok: volle Umdrehung im Bogenmaß
  function glasPlatz() {
    if (!glas || !glas.fertig) return;
    const img = glasHuelle.querySelector('img');
    const kasten = img.getBoundingClientRect(), rc = glas.c.getBoundingClientRect();
    if (!kasten.height || !rc.height || !img.naturalWidth) return;
    /* Das Bild steht im Kasten eingepasst (object-fit: contain, oben mittig): gemessen wird die gezeichnete Flasche */
    const k = Math.min(kasten.width / img.naturalWidth, kasten.height / img.naturalHeight);
    const ri = { width: img.naturalWidth * k, height: img.naturalHeight * k };
    ri.left = kasten.left + (kasten.width - ri.width) / 2; ri.top = kasten.top;
    glas.r.groesse();
    const tiefer = parseFloat(getComputedStyle(html).getPropertyValue('--zl-tl-glas-tiefer')) || 0;
    glas.r.setze([{ sorte: glas.sorte, x: ri.left - rc.left + ri.width / 2, y: ri.top - rc.top + ri.height * (GLAS_OBEN + tiefer), h: ri.height * GLAS_HOEHE }]);
  }
  function glasDrehen(an) {
    if (!glas || !glas.fertig) return;
    cancelAnimationFrame(glasLauf);
    const start = glasStart();
    if (!an) { glas.r.dreh = start; glas.r.zeichne(); return; }
    const dauer = zeitMs('--zl-tl-produkt-auftritt') || 1200; // token-ok: Ersatz, falls der Token fehlt
    const t0 = performance.now();
    const schritt = (jetzt) => {
      const t = Math.min(1, (jetzt - t0) / dauer);
      glas.r.dreh = start * Math.pow(1 - t, 3); /* weich bis nach vorn, ohne Überschwingen */ // token-ok: Kurve
      glas.r.zeichne();
      if (t < 1) glasLauf = requestAnimationFrame(schritt);
    };
    glasLauf = requestAnimationFrame(schritt);
  }
  function glasStellen() {
    if (!glasHuelle) return;
    const an = S.wheatAuftritt === 'drehen' && !reduced.matches;
    glasHuelle.toggleAttribute('data-glas-an', !!(an && glas && glas.fertig));
    if (!an || glasLaedt) { glasPlatz(); return; }
    const d = glasHuelle.dataset;
    glasLaedt = new Promise((ok, nein) => {
      if (window.zlFlasche) { ok(); return; }
      const sk = document.createElement('script'); sk.src = d.tlGlas; sk.onload = ok; sk.onerror = nein; document.head.appendChild(sk);
    }).then(() => {
      const c = document.createElement('canvas');
      c.className = 'zl-tl-glas'; c.setAttribute('aria-hidden', 'true');
      glasHuelle.appendChild(c);
      const bilder = {}; bilder[d.glasSorte] = { flasche: d.glasFlasche, maske: d.glasMaske, etikett: d.glasEtikett };
      const r = new window.zlFlasche.Reihe(c, { bilder, hilfen: { profil: d.glasProfil, licht: d.glasLicht, kappe: d.glasKappe, kappeLicht: d.glasKappeLicht, etikettAlpha: d.glasEtikettAlpha } });
      if (r.ohne) { c.remove(); return null; }
      glas = { r, c, sorte: d.glasSorte };
      glasHuelle.querySelector('img').addEventListener('load', glasPlatz);
      return r.lade(d.glasSorte);
    }).then(() => {
      if (!glas) return;
      glas.fertig = true;
      glasHuelle.toggleAttribute('data-glas-an', S.wheatAuftritt === 'drehen' && !reduced.matches);
      requestAnimationFrame(() => { glasPlatz(); glasDrehen(glasFolie.classList.contains('is-aktiv')); });
    }).catch(() => {});
  }
  if (glasFolie) {
    new MutationObserver(() => {
      const aktiv = glasFolie.classList.contains('is-aktiv');
      if (aktiv && !glasWarAktiv) glasDrehen(true);
      else if (!aktiv && glasWarAktiv) setTimeout(() => { if (!glasFolie.classList.contains('is-aktiv')) glasDrehen(false); }, zeitMs('--zl-tl-blende'));
      glasWarAktiv = aktiv;
    }).observe(glasFolie, { attributes: true, attributeFilter: ['class'] });
  }

  /* Linksbündig heißt optisch bündig: Große Schrift hat vor dem ersten Buchstaben Luft im Zeichen (beim L, E, P in der
     Überschrift rund 8 px), der sichtbare Strich stünde sonst rechts neben Logo, Etikett und Button. Jede Textzeile rückt
     um genau diese Luft ihres ersten Zeichens nach links. Nur, wo Text links steht. */
  const tinte = document.createElement('canvas').getContext('2d');
  function kantenStellen() {
    const ziele = [];
    root.querySelectorAll('[data-tl-folie5] .zl-tl-text > :is(.zl-tl-name, .zl-tl-zeile, .zl-tl-preis, .zl-tl-pflicht, .zl-tl-dazu, [data-zl-wahl])').forEach((el) => {
      el.style.removeProperty('margin-left');
      // Mehrere Fassungen übereinander (Lauf der Auszeichnungen, Wahl der Überschrift): jede Fassung bekommt ihre eigene
      // Luft, sonst springt der sichtbare Strich bei jedem Wechsel um die Luft des anderen ersten Buchstabens
      if (getComputedStyle(el).display === 'grid' && el.children.length > 1) ziele.push(...el.children);
      else ziele.push(el);
    });
    ziele.forEach((el) => {
      el.style.removeProperty('margin-left');
      const cs = getComputedStyle(el.closest('.zl-tl-text > *'));
      if (cs.textAlign !== 'left' && cs.textAlign !== 'start') return;
      const kante = el.getBoundingClientRect().left;
      // Schrift des ersten sichtbaren Zeichens (es kann in einem kleineren Teil stehen, etwa im durchgestrichenen Preis)
      const gang = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      let knoten = gang.nextNode();
      while (knoten && !knoten.textContent.trim()) knoten = gang.nextNode();
      if (!knoten) return;
      const zeichen = knoten.textContent.trim()[0];
      const quelle = getComputedStyle(knoten.parentElement);
      // Positiv: Luft vor dem Strich, der Text rückt nach links. Negativ: das Zeichen ragt über die Kante, es rückt nach rechts.
      // Gemessen an den Pixeln (window.zlTinte, assets/zl-custom.js): measureText meldet in Safari keine Luft
      let luft;
      if (window.zlTinte) luft = window.zlTinte(zeichen, quelle);
      else { tinte.font = `${quelle.fontWeight} ${quelle.fontSize} ${quelle.fontFamily}`; luft = -tinte.measureText(zeichen).actualBoundingBoxLeft; }
      if (Math.abs(luft) > 0.3) el.style.marginLeft = (-luft).toFixed(1) + 'px'; // token-ok: gemessene Luft vor dem ersten Zeichen
      // Große Schrift über mehrere Zeilen („Easy“ / „Wheat“): jede weitere Zeile mit der Luft ihres eigenen ersten Zeichens
      if (window.zlZeilenKante && parseFloat(quelle.fontSize) >= 24) window.zlZeilenKante(el, kante); // token-ok: darunter ist die Luft kleiner als ein Pixel
    });
    /* Kapseln (Etikett „Neu“, Ersparnis) sind Grafiken: Ihr Halbkreis lässt sie eingerückt wirken, obwohl der Kasten auf
       der Kante steht (Moritz, 12.10.2026). Sie ragen um halbe Höhe × --zl-kapsel-ausgleich vor die Kante (docs/abstaende.md). */
    const ausgleich = parseFloat(getComputedStyle(html).getPropertyValue('--zl-kapsel-ausgleich')) || 0;
    root.querySelectorAll('[data-tl-folie5] .zl-tl-text > .zl-tl-etikett').forEach((el) => {
      el.style.removeProperty('margin-left');
      const name = el.parentElement.querySelector('.zl-tl-name');
      const ta = getComputedStyle(name || el.parentElement).textAlign;
      if (ta !== 'left' && ta !== 'start') return;
      const h = el.offsetHeight;
      if (!h || parseFloat(getComputedStyle(el).borderTopLeftRadius) < h / 2) return;
      el.style.marginLeft = (-(h / 2) * ausgleich).toFixed(1) + 'px';
    });
  }
  // Show am Desktop (CLAUDE.md, Erster Bildschirm am Desktop): Die Spalte des Textes endet 48 vor dem Produkt, der Text läuft
  // nie darüber. Das Produkt ist ein freigestelltes Bild (gemessen) oder steht im Foto ab data-produkt-links Prozent der
  // Bildbreite. Der Name ist auf jeder Folie gleich groß: so groß, dass das längste Wort jeder Folie in ihre Spalte passt,
  // höchstens --zl-tl-name-show. Wörter werden nie getrennt, ein Name aus zwei Wörtern darf in zwei Zeilen stehen.
  const lage = (el, anc) => { let x = 0, e = el; while (e && e !== anc) { x += e.offsetLeft; e = e.offsetParent; } return x; };
  function textSpalten() {
    const folien = [...root.querySelectorAll('.zl-tl-folie5[data-tl-k]:not([data-text-eigen])')];
    root.style.removeProperty('--tl-name-show-fit');
    root.style.removeProperty('--tl-skala');
    folien.forEach((f) => f.style.removeProperty('--tl-spalte'));
    if (!desktop.matches) return;
    const hs = getComputedStyle(html);
    const luft = parseFloat(hs.getPropertyValue('--zl-space-6')) || 0;
    const kante = parseFloat(hs.getPropertyValue('--tl-kante')) || parseFloat(getComputedStyle(root).getPropertyValue('--tl-kante')) || 0;
    const voll = parseFloat(hs.getPropertyValue('--zl-tl-name-show')) || 0;
    // Erster Bildschirm wird als Ganzes kleiner (CLAUDE.md): Name, Zeile und ihr Abstand im Maß der Breite zwischen den
    // Kanten des Logos, bezogen auf 1440 px (--zl-tl-name-bezug), breiter bleibt alles in voller Größe. Der Name nie unter
    // --zl-tl-name-show-min, die Zeile liest --tl-skala in zl-teaser-labor.css.
    const bezug = parseFloat(hs.getPropertyValue('--zl-tl-name-bezug')) || 0;
    const minName = parseFloat(hs.getPropertyValue('--zl-tl-name-show-min')) || 0;
    const skala = bezug ? Math.min(1, (html.clientWidth - 2 * kante) / bezug) : 1;
    root.style.setProperty('--tl-skala', skala.toFixed(4));
    const groesste = Math.max(minName, Math.floor(voll * skala));
    let fit = groesste;
    folien.forEach((f) => {
      const breite = f.offsetWidth;
      if (!breite) return;
      let links = breite;
      const anteil = parseFloat(f.dataset.produktLinks);
      const ende = parseFloat(f.dataset.produktRechts);
      const g = [...f.querySelectorAll('.zl-tl-bild img')].find((i) => i.offsetWidth && i.naturalWidth && getComputedStyle(i).objectFit === 'cover');
      if (!Number.isNaN(anteil) && !Number.isNaN(ende) && g) {
        // Produkt im Foto mit Anfang und Ende: Es steht später im Rahmen (produktStellen) oder, wo der Rahmen nicht passt,
        // 48 nach dem Ende des Texts. Für den Rahmen wird der Name nicht kleiner: Der Text darf so weit reichen, wie das
        // Produkt an seiner äußersten Lage rechts 48 Luft lässt (Foto höchstens so groß, dass das Produkt ganz zu sehen ist).
        const H = (g.closest('.zl-tl-bild') || f).offsetHeight;
        links = produktLinksMax(breite, g.naturalWidth, anteil / 100, ende / 100, fotoGrenzen(f, breite, H, g.naturalWidth, g.naturalHeight)); // token-ok: Prozent in Anteil
      } else if (!Number.isNaN(anteil) && g) {
        const sk = Math.max(g.offsetWidth / g.naturalWidth, g.offsetHeight / g.naturalHeight);
        const dw = g.naturalWidth * sk;
        const ox = (parseFloat(getComputedStyle(g).objectPosition) || 50) / 100; // token-ok: Prozent in Anteil
        links = lage(g, f) + (g.offsetWidth - dw) * ox + (anteil / 100) * dw; // token-ok: Prozent in Anteil
      }
      // Freigestelltes Produkt: linke Kante des Bilds, wie es im Kasten steht (contain, mittig). Das Modell des Kalenders
      // liegt genau darauf; seine Fläche ist rundum größer (Platz für Schatten) und zählt deshalb nicht.
      // Bild E: Die Fläche des Produkts richtet sich nach dem Text (beginnt 48 nach seinem Ende, --tl-nah-links), der Name
      // behält deshalb seine Größe, und das Produkt wird schmaler (Rahmen, 17.10.2026)
      if (f.dataset.bild !== 'e') f.querySelectorAll('.zl-tl-nah').forEach((n) => {
        if (!n.offsetWidth) return;
        let l = lage(n, f);
        const i = n.querySelector('img');
        if (i && i.offsetWidth && i.naturalWidth && getComputedStyle(i).objectFit === 'contain') {
          const sk = Math.min(i.offsetWidth / i.naturalWidth, i.offsetHeight / i.naturalHeight);
          l = lage(i, f) + (i.offsetWidth - i.naturalWidth * sk) / 2;
        }
        links = Math.min(links, l);
      });
      const spalte = Math.max(0, Math.floor(links - luft));
      f.style.setProperty('--tl-spalte', spalte + 'px');
      const n = f.querySelector('.zl-tl-name');
      if (!n || !n.firstChild) return;
      const fs = parseFloat(getComputedStyle(n).fontSize);
      let wort = 0;
      const r = document.createRange();
      const tw = document.createTreeWalker(n, NodeFilter.SHOW_TEXT);
      let t;
      while ((t = tw.nextNode())) {
        const re = /\S+/g; let m;
        while ((m = re.exec(t.textContent))) { r.setStart(t, m.index); r.setEnd(t, m.index + m[0].length); wort = Math.max(wort, r.getBoundingClientRect().width); }
      }
      if (wort > 0) fit = Math.min(fit, Math.floor(fs * (spalte - kante) / wort));
    });
    if (fit < voll) root.style.setProperty('--tl-name-show-fit', Math.max(minName, fit) + 'px');
  }
  /* Produkt in Teaserflächen (CLAUDE.md): Ein Produkt im Foto (data-produkt-links und -rechts, Prozent der Bildbreite)
     steht am Desktop im Rahmen: rechts so viel Luft wie links vom Text (produktRahmen). Das Foto wird dafür verschoben und
     nur so weit vergrößert, wie es nötig ist, damit es die Fläche füllt. */
  /* Grenze oben für das Produkt, je Folie als --tl-oben (px ab Oberkante der Folie): am Desktop die Grundlinie der Links im
     Kopf (Adventskalender, Starterpaket), am Handy die Unterkante des Logos samt Augen. Steht am Handy Text über dem Produkt,
     ist sein Ende die Grenze. Gemessen am Kopf in Ruhe, nicht an seiner Lage beim Scrollen. */
  function kopfGrenze() {
    const l = desktop.matches ? [...document.querySelectorAll('.zlk-nav__punkt')].find((a) => a.offsetWidth) : null;
    const kopf = l ? l.closest('.site-header, header') : null;
    if (l && kopf) {
      const p = document.createElement('span');
      p.className = 'zl-tl-grundlinie';
      l.appendChild(p);
      const y = p.getBoundingClientRect().top - kopf.getBoundingClientRect().top;
      p.remove();
      return y;
    }
    const logo = document.querySelector('.zl-logo-kopf__link svg, .zl-logo-kopf__link img');
    const k2 = logo && logo.closest('.site-header, header');
    return logo && k2 ? logo.getBoundingClientRect().bottom - k2.getBoundingClientRect().top : 0;
  }
  function obenStellen() {
    const grenze = kopfGrenze();
    root.querySelectorAll('.zl-tl-folie5[data-tl-k]').forEach((f) => {
      let oben = grenze - (f.getBoundingClientRect().top + window.scrollY);
      const t = f.querySelector('.zl-tl-text');
      // Am Handy steht der Text über dem Produkt, außer auf einem Foto über die ganze Fläche (dort liegt er darauf)
      if (!desktop.matches && f.dataset.lage !== 'voll' && t && t.offsetHeight) oben = Math.max(oben, t.offsetTop + t.offsetHeight);
      f.style.setProperty('--tl-oben', Math.round(oben) + 'px');
    });
  }
  /* Rahmen am Desktop (Moritz, 17.10.2026): Das Produkt im Foto steht mit seiner rechten Kante so weit vom rechten Rand
     wie der Text von links (die Kante des Logos). Das Foto wird dafür verschoben und nur so weit vergrößert, wie es die
     Fläche füllen muss. rechts ist das Ende des Texts: Käme das Produkt ihm näher als luft, rückt es nach rechts. */
  function kanteVon() { return parseFloat(getComputedStyle(html).getPropertyValue('--tl-kante')) || parseFloat(getComputedStyle(root).getPropertyValue('--tl-kante')) || 0; }
  // Grenzen für die Größe des Fotos (Breite in px): min hält das Produkt senkrecht mittig zwischen der Grenze oben und dem
  // unteren Rand, max lässt es dort ganz und mit Luft zu sehen (läuft es im Foto oben oder unten hinaus, gilt keine Grenze)
  function fotoGrenzen(f, W, H, nw, nh) {
    const o = parseFloat(f.dataset.produktOben) / 100, u = parseFloat(f.dataset.produktUnten) / 100; // token-ok: Prozent in Anteil
    const rand = 0.005; // token-ok: Produkt läuft im Foto aus dem Bild, Anteil der Bildhöhe
    const ganz = !Number.isNaN(o) && !Number.isNaN(u) && u > o && o > rand && u < 1 - rand;
    const oben = parseFloat(f.style.getPropertyValue('--tl-oben')) || 0;
    const s0 = Math.max(W / nw, H / nh);
    if (!ganz) return { min: nw * s0, max: Infinity };
    const cy = (o + u) / 2, Yc = (oben + H) / 2;
    const min = Math.max(nw * s0, Math.max(Yc / cy, (H - Yc) / (1 - cy)) * nw / nh);
    // Mindestens 36 Luft über und unter dem Produkt, wie bei freigestellten Produkten
    const luft = parseFloat(getComputedStyle(html).getPropertyValue('--zl-space-5')) || 0;
    return { min, max: Math.max(min, ((H - oben - 2 * luft) / (u - o)) * nw / nh) };
  }
  // Am weitesten rechts, wo das Produkt im Foto stehen kann, ohne dass das Foto größer wird als erlaubt: seine linke Kante
  function produktLinksMax(W, nw, a, e, g) {
    const c = (a + e) / 2;
    let links = -Infinity;
    for (let x = 0; x <= W; x += 2) { // token-ok: Schritt der Suche in px
      const w = Math.max(g.min, x / c, (W - x) / (1 - c));
      if (w <= g.max + 0.5) links = Math.max(links, x - (c - a) * w); // token-ok: halber Pixel Toleranz
    }
    return links === -Infinity ? W - (1 - a) * g.min : links;
  }
  function produktRahmen(W, H, nw, nh, a, e, hdMin, kante, rechts, luft, wMax = Infinity) {
    const c = (a + e) / 2;
    const s0 = Math.max(W / nw, H / nh);
    const breite = (x) => Math.max(nw * s0, x / c, (W - x) / (1 - c), hdMin * nw / nh);
    let wd = Math.max(nw * s0, hdMin * nw / nh);
    let X = 0;
    for (let i = 0; i < 16; i++) { X = W - kante - (e - c) * wd; wd = breite(X); } // token-ok: Annäherung, nach wenigen Schritten fest
    if ((rechts !== null && X - (c - a) * wd - rechts < luft) || wd > wMax + 0.5) { // token-ok: halber Pixel Toleranz
      // Der Rahmen passt nicht: unter allen Lagen mit 48 Luft zum Text die, deren Luft rechts der Kante am nächsten kommt,
      // bei gleicher Luft die mit dem kleineren Foto
      let best = null;
      for (let x = 0; x <= W; x += 2) { // token-ok: Schritt der Suche in px
        const w = breite(x);
        if ((rechts !== null && x - (c - a) * w - rechts < luft) || w > wMax + 0.5) continue; // token-ok: halber Pixel Toleranz
        const d = Math.abs(W - x - (e - c) * w - kante);
        if (!best || d < best.d - 0.5 || (Math.abs(d - best.d) <= 0.5 && w < best.w)) best = { d, x, w }; // token-ok: halber Pixel Toleranz
      }
      if (best) { X = best.x; wd = best.w; }
      else { wd = Math.max(nw * s0, hdMin * nw / nh); X = Math.min(c * wd, Math.max(W - (1 - c) * wd, W - kante - (e - c) * wd)); }
    }
    return { X, wd };
  }
  /* Rahmen (Moritz, 17.10.2026) für Bild E: Das freigestellte Produkt steht mit seiner rechten Kante so weit vom rechten
     Rand wie der Text von links. Seine Fläche beginnt so weit links, wie das Produkt bei voller Höhe breit ist, nie näher
     als 48 am Ende des Texts; dann wird es schmaler und füllt die Fläche in der Breite. Gemessen am Text in Ruhe. */
  /* Grafik fürs Probierpaket (Bild E mit .zl-ppa): Sie zählt als Produkt. Gestellt wird an ihren sichtbaren Kanten
     (--zl-ppa-sicht-*, Anteile ihres Kastens), nicht am Kasten: Flaschen und Guide ragen hinaus. Desktop: rechts so viel Luft
     wie die Kante des Logos, links nie näher als 48 am Text, oben und unten im Feld der Bild E (36 Luft), sonst wird sie
     kleiner. Handy: so groß, wie das Feld unter dem Text es erlaubt, links und rechts mindestens --zl-gutter, mittig. */
  function ppStellen(el, ppa) {
    const nah = ppa.closest('.zl-tl-nah');
    if (!nah || !nah.clientHeight) return;
    const cs = getComputedStyle(html);
    const wert = (n, s) => { const v = parseFloat(cs.getPropertyValue(n)); return Number.isNaN(v) ? s : v; };
    const sl = wert('--zl-ppa-sicht-links', 0), sr = wert('--zl-ppa-sicht-rechts', 1), so = wert('--zl-ppa-sicht-oben', 0), su = wert('--zl-ppa-sicht-unten', 1); // token-ok: Ersatz ohne Token, der Kasten selbst
    const format = wert('--zl-ppa-breite-je-hoehe', 0);
    if (!format) return;
    const breiteNachHoehe = nah.clientHeight / (su - so) * format;
    let w;
    if (desktop.matches) {
      const t = el.querySelector('.zl-tl-text');
      let rechts = 0;
      if (t) [...t.children].forEach((k) => {
        if (!k.offsetParent || k.hidden) return;
        const r = document.createRange();
        r.selectNodeContents(k);
        const b = k.matches('.zl-tl-name, .zl-tl-zeile, .zl-tl-dazu, .zl-tl-preis') ? r.getBoundingClientRect() : k.getBoundingClientRect();
        const versatz = k.getBoundingClientRect().left - el.getBoundingClientRect().left - lage(k, el);
        rechts = Math.max(rechts, b.right - el.getBoundingClientRect().left - versatz);
      });
      const luft = wert('--zl-space-6', 0);
      const ende = el.clientWidth - kanteVon();
      w = Math.min(breiteNachHoehe, (ende - rechts - luft) / (sr - sl));
      el.style.setProperty('--tl-nah-links', (ende - w * (sr - sl)).toFixed(1) + 'px');
    } else {
      el.style.removeProperty('--tl-nah-links');
      const innen = ppa.parentElement.clientWidth;
      w = Math.min(breiteNachHoehe, innen / (sr - sl));
    }
    w = Math.max(0, w);
    const h = w / format;
    ppa.style.setProperty('--tl-pp-w', w.toFixed(1) + 'px');
    ppa.style.setProperty('--tl-pp-x', (-((sl + sr) / 2 - 0.5) * w).toFixed(1) + 'px'); // token-ok: Mitte des Kastens
    ppa.style.setProperty('--tl-pp-y', (-((so + su) / 2 - 0.5) * h).toFixed(1) + 'px'); // token-ok: Mitte des Kastens
  }
  function nahRahmen(el) {
    const ppa = el.querySelector('.zl-tl-nah__pp > .zl-ppa');
    if (ppa) { if (el.dataset.bild === 'e') ppStellen(el, ppa); return; }
    const nah = el.querySelector('.zl-tl-nah');
    const bilder = nah ? [...nah.querySelectorAll('img')].filter((i) => i.getClientRects().length && i.naturalWidth) : [];
    if (!desktop.matches || el.dataset.bild !== 'e' || !nah || bilder.length !== 1 || getComputedStyle(bilder[0]).objectFit !== 'contain' || !nah.clientHeight) { el.style.removeProperty('--tl-nah-links'); return; }
    const t = el.querySelector('.zl-tl-text');
    let rechts = 0;
    if (t) [...t.children].forEach((k) => {
      if (!k.offsetParent || k.hidden) return;
      const r = document.createRange();
      r.selectNodeContents(k);
      const b = k.matches('.zl-tl-name, .zl-tl-zeile, .zl-tl-dazu') ? r.getBoundingClientRect() : k.getBoundingClientRect();
      const versatz = k.getBoundingClientRect().left - el.getBoundingClientRect().left - lage(k, el);
      rechts = Math.max(rechts, b.right - el.getBoundingClientRect().left - versatz);
    });
    const i = bilder[0];
    const luft = parseFloat(getComputedStyle(html).getPropertyValue('--zl-space-6')) || 0;
    const pw = nah.clientHeight * i.naturalWidth / i.naturalHeight;
    el.style.setProperty('--tl-nah-links', Math.round(Math.max(rechts + luft, el.clientWidth - kanteVon() - pw)) + 'px');
  }
  function produktStellen() {
    const luft = parseFloat(getComputedStyle(html).getPropertyValue('--zl-space-6')) || 0;
    root.querySelectorAll('.zl-tl-folie5[data-tl-k]').forEach((f) => {
      // Die Zeile unter dem Namen ist nie breiter als der Name: das Ende des Texts setzt der Name
      const name = f.querySelector('.zl-tl-name');
      f.style.removeProperty('--tl-zeile-max');
      if (desktop.matches && name && name.firstChild) {
        const r = document.createRange();
        r.selectNodeContents(name);
        const nb = r.getBoundingClientRect().width;
        if (nb > 0) f.style.setProperty('--tl-zeile-max', Math.ceil(nb) + 'px');
      }
      const a = parseFloat(f.dataset.produktLinks) / 100, e = parseFloat(f.dataset.produktRechts) / 100; // token-ok: Prozent in Anteil
      const g = bildVon(f);
      const weg = () => { delete f.dataset.produktMitte; ['x', 'y', 'w', 'h'].forEach((k) => f.style.removeProperty('--tl-p-' + k)); };
      if (!desktop.matches || Number.isNaN(a) || Number.isNaN(e) || !g || !g.naturalWidth || f.dataset.lage !== 'voll') { weg(); return; }
      const box = g.parentElement.closest('.zl-tl-bild') || f;
      const W = box.clientWidth, H = box.clientHeight;
      if (!W || !H) return;
      const nw = g.naturalWidth, nh = g.naturalHeight;
      const s0 = Math.max(W / nw, H / nh);
      const c = (a + e) / 2;
      // Ende des Texts: der sichtbare Strich des Elements, das am weitesten nach rechts reicht
      const t = f.querySelector('.zl-tl-text');
      const fl = box.getBoundingClientRect().left;
      let rechts = 0;
      if (t) [...t.children].forEach((k) => {
        if (!k.offsetParent || k.hidden) return;
        const r = document.createRange();
        r.selectNodeContents(k);
        const b = k.matches('.zl-tl-name, .zl-tl-zeile, .zl-tl-dazu') ? r.getBoundingClientRect() : k.getBoundingClientRect();
        // Im Wechsel liegt die Schrift einer anderen Folie verschoben: gemessen wird ihr Platz in Ruhe (Lage ohne Verschiebung)
        const versatz = k.getBoundingClientRect().left - f.getBoundingClientRect().left - lage(k, f);
        rechts = Math.max(rechts, b.right - fl - versatz);
      });
      // Senkrecht: das Produkt steht mittig zwischen der Grenze oben (--tl-oben) und dem unteren Rand der Fläche, oben und
      // unten gleich viel Luft. Läuft es im Foto oben oder unten hinaus (0 oder 100), steht das Foto an dieser Kante.
      const o = parseFloat(f.dataset.produktOben) / 100, u = parseFloat(f.dataset.produktUnten) / 100; // token-ok: Prozent in Anteil
      const senk = !Number.isNaN(o) && !Number.isNaN(u) && u > o;
      const rand = 0.005; // token-ok: Produkt läuft im Foto aus dem Bild, Anteil der Bildhöhe
      const oben = parseFloat(f.style.getPropertyValue('--tl-oben')) || 0;
      const cy = (o + u) / 2;
      const Yc = (oben + H) / 2;
      const hdMin = senk && o > rand && u < 1 - rand ? Math.max(Yc / cy, (H - Yc) / (1 - cy)) : 0;
      // Rahmen (Moritz, 17.10.2026): rechts vom sichtbaren Produkt so viel Luft wie links vom Text, die Kante des Logos.
      // Passt das nicht, ohne dem Text näher als 48 zu kommen, rückt das Produkt so wenig wie nötig nach rechts.
      const wMax = fotoGrenzen(f, W, H, nw, nh).max;
      const { X, wd } = produktRahmen(W, H, nw, nh, a, e, hdMin, kanteVon(), rechts, luft, wMax);
      const mittig = false;
      const hd = wd * nh / nw;
      const py = (parseFloat((getComputedStyle(g).objectPosition.split(' ')[1]) || '50') || 50) / 100; // token-ok: Prozent in Anteil
      let y = (H - hd) * py;
      if (hdMin) y = Yc - cy * hd;
      else if (senk && o <= rand) y = 0;
      else if (senk && u >= 1 - rand) y = H - hd;
      f.style.setProperty('--tl-p-x', (X - c * wd).toFixed(1) + 'px');
      f.style.setProperty('--tl-p-y', Math.min(0, Math.max(H - hd, y)).toFixed(1) + 'px');
      f.style.setProperty('--tl-p-w', wd.toFixed(1) + 'px');
      f.style.setProperty('--tl-p-h', hd.toFixed(1) + 'px');
      f.dataset.produktMitte = mittig ? 'fenster' : 'rahmen';
    });
  }
  function lageStellen() {
    namenEinpassen();
    obenStellen(); // die Grenze oben brauchen schon die Spalten des Texts (wie groß das Foto werden darf)
    textSpalten();
    if (schriftDa) kantenStellen();
    glasPlatz();
    // Grund zeroBlack statt des eingestellten: Probierpaket "Der schwarze Moment", Awards am Desktop als Familie oder Etiketten
    const awardsSchwarz = desktop.matches && (S.awardsD === 'familie' || S.awardsD === 'etiketten');
    root.querySelectorAll('[data-paket-formen], [data-tl-folie5][data-siegel-gross]').forEach((el) => {
      const schwarz = el.hasAttribute('data-paket-formen') ? S.paket === 'schwarz' : awardsSchwarz;
      if (el.dataset.grundEigen === undefined) el.dataset.grundEigen = el.dataset.grund;
      el.dataset.grund = schwarz ? 'zeroblack' : el.dataset.grundEigen;
      const g = el.querySelector('.zl-tl-grafik');
      if (g) {
        if (g.dataset.grundEigen === undefined) g.dataset.grundEigen = g.dataset.grund;
        g.dataset.grund = schwarz ? 'zeroblack' : g.dataset.grundEigen;
      }
    });
    root.querySelectorAll('[data-lage-a]').forEach((el) => {
      // Bildsatz je Kampagne: fest (Ein Satz), je Folie aus der Kampagne (Show), sonst für alle gleich
      // Am Desktop kann eine Folie ein eigenes Bild haben (Einstellung "Bild in der Show am Desktop")
      let standard = desktop.matches && el.dataset.showBildD ? el.dataset.showBildD : el.dataset.showBild;
      // Awards am Desktop: Ausstellung (D) oder die ausgezeichneten Flaschen groß (E), Regler "Awards am Desktop"
      const awardsForm = desktop.matches && el.hasAttribute('data-siegel-gross') ? S.awardsD : '';
      if (awardsForm) standard = awardsForm === 'ausstellung' ? 'd' : 'e';
      if (awardsForm) el.dataset.awardsD = awardsForm; else delete el.dataset.awardsD;
      if (!desktop.matches && el.hasAttribute('data-rahmen-g') && el.hasAttribute('data-paket-formen') && (root.dataset.land === 'CH' ? S.paketHandyCh : S.paketHandy) === 'foto') standard = 'g';
      // Probierpaket am Desktop: nah an den Flaschen oder die ganze Platte
      const quelle = el.querySelector('source[data-nah]');
      if (quelle) { const soll = S.paketDesktop === 'weit' ? quelle.dataset.weit : quelle.dataset.nah; if (quelle.srcset !== soll) quelle.srcset = soll; }
      let bild = el.dataset.festBild || (el.matches('[data-tl-folie5]') ? (S.fb[el.dataset.id] || standard) : S.bild) || 'a';
      if (bild === 'g' && !el.querySelector('.zl-tl-bild__g')) bild = 'a';
      el.dataset.bild = bild;
      const grafik = bild === 'c' || bild === 'd' || bild === 'e';
      // Grafik G: am Desktop rechts im Feld, am Handy ganz und scharf über die Fläche
      if (bild === 'g' && el.hasAttribute('data-g-schleier')) el.dataset.gHandy = S.gHandy;
      else delete el.dataset.gHandy;
      // Grafik mit eigener Fassung für den Desktop füllt auch dort die ganze Fläche
      const lage = grafik ? 'grafik' : bild === 'g' ? ((desktop.matches && !el.hasAttribute('data-g-desktop')) || (!desktop.matches && el.hasAttribute('data-rahmen-g')) ? 'tief' : 'voll') : S.lage !== 'block' && !el.dataset.festBild ? S.lage : (bild === 'b' ? el.dataset.lageB : el.dataset.lageA);
      el.dataset.lage = lage || 'voll';
      if (grafik) el.dataset.ton = el.dataset.grund === 'zeroblack' || el.dataset.farbe === 'hell' ? 'dunkel' : 'hell';
      else if (el.dataset.lage === 'tief') tonMessen(el);
      else delete el.dataset.ton;
      // Grauschleier über der Grafik am Handy: Schrift und Kopf in Weiß
      if (bild === 'g' && !desktop.matches && el.dataset.gHandy && S.gHandy.indexOf('schleier') === 0) el.dataset.ton = 'dunkel';
      if (bild === 'g' && el.dataset.lage === 'voll' && el.dataset.farbe === 'hell') el.dataset.ton = 'dunkel';
      if (bild === 'g' && desktop.matches && el.dataset.lage === 'voll' && el.hasAttribute('data-g-desktop') && (el.hasAttribute('data-g-schleier') || el.hasAttribute('data-g-dunkel'))) el.dataset.ton = 'dunkel';
      // Bild E am Handy angeschnitten (Einstellung "Flasche am Handy angeschnitten"): die Flasche groß, der untere Rand
      // schneidet sie am Ende des roten Etiketts oder unter dem Etikett
      const schnitte = (el.dataset.anschnitte || '').split(',').map((n) => parseFloat(n) / 100);
      let schnitt = S.anschnitt === 'rot' ? schnitte[0] : S.anschnitt === 'etikett' ? schnitte[1] : NaN;
      if (awardsForm) schnitt = awardsForm === 'etiketten' ? schnitte[1] : NaN;
      if (bild === 'e' && schnitt > 0) { el.dataset.anschnitt = ''; el.style.setProperty('--tl-anschnitt', schnitt); }
      else { delete el.dataset.anschnitt; el.style.removeProperty('--tl-anschnitt'); }
      // Bild E am Desktop: das Produkt steht mittig zwischen dem Ende des Texts und der rechten Kante, nie unter dem Text
      if (bild === 'e' && desktop.matches) {
        const t = el.querySelector('.zl-tl-text');
        const links = el.getBoundingClientRect().left;
        let rechts = 0;
        if (t) [...t.children].forEach((k) => {
          if (!k.offsetParent || k.hidden) return; /* auch unsichtbare Folien messen: sie stehen schon an ihrem Platz */
          const r = document.createRange();
          r.selectNodeContents(k);
          const b = k.matches('.zl-tl-name, .zl-tl-zeile, .zl-tl-dazu') ? r.getBoundingClientRect() : k.getBoundingClientRect();
          rechts = Math.max(rechts, b.right - links);
        });
        if (rechts > 0) el.style.setProperty('--tl-text-rechts', Math.round(rechts) + 'px');
        nahRahmen(el);
        /* Erst mit der echten Schrift steht fest, wo der Text endet: bis dahin bleibt das Produkt unsichtbar, statt zu springen */
        if (schriftDa) el.dataset.gemessen = '';
      } else { el.style.removeProperty('--tl-text-rechts'); el.dataset.gemessen = ''; }
      untenMessen(el);
      delete el.dataset.passt;
      delete el.dataset.gerahmt;
      if (el.dataset.lage === 'voll' || desktop.matches) { el.style.removeProperty('--tl-frei'); return; }
      const t = el.querySelector('.zl-tl-text');
      if (!t || !t.offsetHeight) return;
      const luft = parseFloat(getComputedStyle(root).getPropertyValue('--zl-space-3')) || 0;
      const frei = Math.round(t.offsetTop + t.offsetHeight + luft);
      el.style.setProperty('--tl-frei', frei + 'px');
      // Foto tief mit Rahmen um das Produkt (Einstellung "Produkt im Bild"): Das Produkt steht so groß wie möglich zwischen
      // Text und Segmenten, nie angeschnitten, unten auf der Linie über den Segmenten. Was vom Foto darüber und darunter
      // übersteht, läuft weich aus, ein heller Boden unter dem Produkt verschwindet.
      const rahmen = el.dataset['rahmen' + bild.toUpperCase()];
      if (el.dataset.lage === 'tief' && el.matches('[data-tl-folie5]') && rahmen) {
        const img = bildVon(el);
        const stellen = () => {
          if (!img.naturalWidth) return;
          const [x0, y0, x1, y1] = rahmen.split(',').map((n) => parseFloat(n) / 100);
          const seg = show.querySelector('[data-tl-segmente5]');
          const unten = seg.getBoundingClientRect().top - el.getBoundingClientRect().top - luft;
          const verlauf = luft;
          const W = el.clientWidth;
          const hoehe = unten - frei - verlauf;
          const s = Math.min(W / ((x1 - x0) * img.naturalWidth), hoehe / ((y1 - y0) * img.naturalHeight));
          let iw = img.naturalWidth * s, ih = img.naturalHeight * s;
          let x = W / 2 - ((x0 + x1) / 2) * iw;
          x = iw >= W ? Math.min(0, Math.max(W - iw, x)) : (W - iw) / 2;
          let y = unten - y1 * ih;
          if (el.hasAttribute('data-g-tisch')) {
            /* Foto auf dem Metalltisch (Schweiz): Der Tisch steht als Fläche zwischen Button und Segmenten, darüber und
               darunter gleich viel Abstand (Gruppenwechsel). Die Flaschen stehen mittig darauf, so breit wie der Rahmen
               es erlaubt. Der Tisch füllt die Fläche, seine Kanten oben und unten sind die Kanten der Fläche. */
            const abstand = parseFloat(getComputedStyle(root).getPropertyValue('--zl-gap-groups')) || 0;
            const oben = t.offsetTop + t.offsetHeight + abstand;
            const unterkante = seg.getBoundingClientRect().top - el.getBoundingClientRect().top - abstand;
            const [p0, p1] = (getComputedStyle(root).getPropertyValue('--zl-tl-tisch-platte').trim() || '5,92').split(',').map((n) => parseFloat(n) / 100); // token-ok: Ersatz, falls der Token fehlt
            const sw = W / ((x1 - x0) * img.naturalWidth);
            const sh = (unterkante - oben) / ((p1 - p0) * img.naturalHeight);
            const st = Math.max(sw, sh);
            iw = img.naturalWidth * st; ih = img.naturalHeight * st;
            x = Math.min(0, Math.max(W - iw, W / 2 - ((x0 + x1) / 2) * iw));
            y = (oben + unterkante) / 2 - ((y0 + y1) / 2) * ih;
            y = Math.min(oben - p0 * ih, Math.max(unterkante - p1 * ih, y)); /* nie über die Platte hinaus */
            el.style.setProperty('--tl-r-x', x.toFixed(1) + 'px');
            el.style.setProperty('--tl-r-y', y.toFixed(1) + 'px');
            el.style.setProperty('--tl-r-w', iw.toFixed(1) + 'px');
            el.style.setProperty('--tl-r-h', ih.toFixed(1) + 'px');
            el.style.setProperty('--tl-r-a', (oben - y).toFixed(1) + 'px');
            el.style.setProperty('--tl-r-b', (unterkante - y).toFixed(1) + 'px');
            el.dataset.gerahmt = 'tisch';
            return;
          }
          el.style.setProperty('--tl-r-x', x.toFixed(1) + 'px');
          el.style.setProperty('--tl-r-y', y.toFixed(1) + 'px');
          el.style.setProperty('--tl-r-w', iw.toFixed(1) + 'px');
          el.style.setProperty('--tl-r-h', ih.toFixed(1) + 'px');
          el.style.setProperty('--tl-r-a', Math.max(0, frei - y).toFixed(1) + 'px');
          el.style.setProperty('--tl-r-b', (unten - y + verlauf).toFixed(1) + 'px');
          el.dataset.gerahmt = iw >= W ? 'breit' : 'schmal';
        };
        if (img && img.complete) stellen();
        else if (img) img.addEventListener('load', stellen, { once: true });
      } else if (el.dataset.lage === 'tief' && el.matches('[data-tl-folie5]')) {
        // Foto tief in der Show: Ist die Fläche unter dem Text breiter als das Foto, steht das Foto ganz darin statt angeschnitten
        const img = bildVon(el);
        const passen = () => {
          if (!img.naturalWidth) return;
          const format = img.naturalWidth / img.naturalHeight;
          // bis über die Segmente (Zone: 18 über der Kante, Segment, 18 Luft)
          const seg = show && show.querySelector('[data-tl-segmente5]');
          const zone = seg ? el.getBoundingClientRect().bottom - seg.getBoundingClientRect().top + luft : 0;
          const h = el.clientHeight - frei - zone;
          el.style.setProperty('--tl-format', format.toFixed(4));
          if (h > 0 && el.clientWidth / h > format) el.dataset.passt = 'ganz';
          else delete el.dataset.passt;
        };
        if (img && img.complete) passen();
        else if (img) img.addEventListener('load', passen, { once: true });
      }
    });
    obenStellen();
    root.querySelectorAll('.zl-tl-folie5[data-tl-k]').forEach(nahRahmen);
    produktStellen();
    // Der Kalender als Modell folgt seinem Bild, wenn sich die Lage ändert
    try { if (kalHuelle) kalPlatz(); } catch (e) { /* noch nicht bereit */ }
  }

  /* ---------- Graue Leiste: Antippen eines Geschenks hebt es an und nennt es im Wort, noch einmal tippen nimmt es zurück ---------- */
  document.querySelectorAll('[data-tl-leiste]').forEach((l) => {
    const wort = l.querySelector('[data-tl-leiste-wort]');
    const dinge = [...l.querySelectorAll('[data-tl-leiste-ding]')];
    dinge.forEach((d) => d.addEventListener('click', (e) => {
      e.stopPropagation();
      const an = !d.classList.contains('ist-dran');
      dinge.forEach((x) => x.classList.toggle('ist-dran', an && x === d));
      if (wort) wort.textContent = an ? d.dataset.tlLeisteDing + ', geschenkt' : wort.dataset.standard;
    }));
  });

  /* ---------- Anwenden ---------- */
  function apply() {
    root.dataset.r = S.r;
    // Bewertungen als Reihe zum Wischen (live), im Labor mit „heute“ die alte Fassung zum Vergleich (assets/zl-bewertungen.css und .js)
    if (live) delete html.dataset.zlBw; else html.dataset.zlBw = S.bewertungen;
    if (live) delete html.dataset.zlBwAuftritt; else html.dataset.zlBwAuftritt = S.bwAuftritt || 'an';
    // Bekannt aus: Vorschlag im Labor (sections/zl-start-bekannt.liquid), live entscheidet die Einstellung der Sektion
    // Live gelten die entschiedenen Werte (START), gesetzt schon vor dem ersten Bild in sections/zl-teaser-labor.liquid
    if (!nurShow) { delete html.dataset.zlHoehe; delete html.dataset.zlBlockLage; delete html.dataset.zlSchrift; delete html.dataset.zlWort; delete html.dataset.zlZahl; } else {
      const vorher = `${html.dataset.zlSchrift}|${html.dataset.zlWort}|${html.dataset.zlZahl}|${html.dataset.zlBlockLage}`;
      html.dataset.zlHoehe = S.hoehe || 'm'; html.dataset.zlBlockLage = S.blockLage || 'achse'; html.dataset.zlSchrift = imLabor ? (S.schrift || 'desktop') : 'desktop'; if (imLabor) { html.dataset.zlWort = S.kapitelwort || 'gross'; html.dataset.zlZahl = S.zahl || 'beleg'; zahlText(); } else { delete html.dataset.zlWort; delete html.dataset.zlZahl; } // außerhalb des Labors gelten die Werte aus zl-tokens.css und der Vorlage
      // Andere Schriftgröße oder Achse: die Kante der Texte neu messen lassen (assets/zl-custom.js misst nach jedem resize)
      if (vorher !== `${html.dataset.zlSchrift}|${html.dataset.zlWort}|${html.dataset.zlZahl}|${html.dataset.zlBlockLage}`) window.dispatchEvent(new Event('resize'));
      document.querySelectorAll('.zl-aw[data-labor]').forEach((b) => { if (S.aw) b.dataset.grafik = S.aw; });
    }
    const achse = nurShow && (S.blockLage || 'achse') === 'achse' && (S.hoehe || 'm') !== 'aus' ? 'mitte' : (S.achse || 'kante');
    if (live) { delete html.dataset.zlBa; delete html.dataset.zlBaMarke; delete html.dataset.zlGrund; html.dataset.zlAchse = achse; } else { html.dataset.zlBa = S.bekanntAus || 'kapitel'; html.dataset.zlBaMarke = S.bekanntMarke || 'logo'; html.dataset.zlAchse = achse; html.dataset.zlGrund = S.grund || 'an'; }
    // Überschrift des Kapitels: im Labor Kandidaten zum Vergleichen, live steht die Einstellung der Sektion
    if (!live) { const t = document.querySelector('.zl-ba-kapitel__titel'); const o = (FELDER[5].find((f) => f.key === 'baTitel') || {}).optionen || []; const w = o.find((x) => x[0] === S.baTitel); if (t && w) t.textContent = w[1]; }
    // Die schwarze Vorschau-Leiste deckt den unteren Rand ab, live gibt es sie nicht
    html.dataset.zlLeiste = S.leiste;
    root.style.setProperty('--tl-schleier', S.schleier);
    root.dataset.bild = S.bild;
    root.dataset.etikett = S.etikett;
    root.dataset.preis = S.preis;
    root.dataset.chips = S.chips;
    root.dataset.timer = S.timer;
    root.querySelectorAll('.zl-tl-kachel').forEach((k) => { k.classList.toggle('zl-tl-oben', S.ort === 'oben'); k.classList.toggle('zl-tl-unten', S.ort === 'unten'); });
    lageStellen();
    root.style.setProperty('--tl-tiefe', S.tiefe);
    root.style.setProperty('--tl-blende', S.blende === 'an' ? '' : '0s');
    if (S.blende === 'an') root.style.removeProperty('--tl-blende');
    root.style.setProperty('--tl-timer', S.timerS + 's');
    const k = document.querySelector('[data-tl-knopf]');
    if (k) k.textContent = nurShow ? 'Regler' : 'Regler · ' + S.r + ' ' + NAMEN[S.r];
    buehneFit();
    buehneTiefe();
    geschichteZeigen(gIndex, false);
    showStellen();
    tickerStellen();
    darunterStellen();
    kopfStellen();
  }

  /* ---------- 2. Bühne ---------- */
  const spur = root.querySelector('[data-tl-spur]');
  const folien = spur ? [...spur.querySelectorAll('[data-tl-folie]')] : [];
  const punkte = [...root.querySelectorAll('[data-tl-punkte] span')];
  function buehneFit() {
    if (S.r !== '2') return;
    root.querySelectorAll('[data-tl-fit]').forEach((el) => {
      el.style.setProperty('--tl-fit', '100px'); // token-ok: Messgröße, aus der die passende Größe gerechnet wird
      const breite = el.clientWidth;
      const text = el.scrollWidth;
      if (!breite || !text) return;
      const groesse = Math.min(100 * breite / text, window.innerHeight * 0.2);
      el.style.setProperty('--tl-fit', groesse.toFixed(1) + 'px');
    });
  }
  function buehneTiefe() {
    if (!spur || S.r !== '2') return;
    const w = spur.clientWidth || 1;
    folien.forEach((f) => {
      const versatz = reduced.matches ? 0 : -(f.offsetLeft - spur.scrollLeft) * S.tiefe;
      const fl = f.querySelector('[data-tl-tiefe]');
      if (fl) fl.style.setProperty('--tl-versatz', versatz.toFixed(1) + 'px');
    });
    const i = clamp(Math.round(spur.scrollLeft / w), 0, punkte.length - 1);
    punkte.forEach((p, j) => p.classList.toggle('is-aktiv', j === i));
  }
  if (spur) {
    let geplant = false;
    spur.addEventListener('scroll', () => {
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(() => { geplant = false; buehneTiefe(); });
    }, { passive: true });
  }

  /* ---------- 3. Geschichten ---------- */
  const gWrap = root.querySelector('.zl-tl-geschichten');
  const geschichten = [...root.querySelectorAll('[data-tl-geschichte]')];
  const segmente = [...root.querySelectorAll('[data-tl-segmente] span')];
  let gIndex = 0;
  let gTimer = 0;
  function geschichteZeigen(i, merken) {
    if (!geschichten.length) return;
    gIndex = (i + geschichten.length) % geschichten.length;
    geschichten.forEach((g, j) => g.classList.toggle('is-aktiv', j === gIndex));
    segmente.forEach((s, j) => {
      s.classList.toggle('is-fertig', j < gIndex);
      s.classList.remove('is-aktiv');
    });
    const akt = segmente[gIndex];
    if (akt) { void akt.offsetWidth; akt.classList.add('is-aktiv'); }
    clearTimeout(gTimer);
    if (S.r === '3' && S.timer === 'an' && !reduced.matches) {
      gTimer = setTimeout(() => geschichteZeigen(gIndex + 1, true), S.timerS * 1000);
    }
    if (merken) kopfStellen();
  }
  if (gWrap) {
    root.querySelector('[data-tl-weiter]').addEventListener('click', () => geschichteZeigen(gIndex + 1, true));
    root.querySelector('[data-tl-zurueck]').addEventListener('click', () => geschichteZeigen(gIndex - 1, true));
    let sx = 0;
    let sy = 0;
    gWrap.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    gWrap.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - sx;
      const dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) geschichteZeigen(gIndex + (dx < 0 ? 1 : -1), true);
    }, { passive: true });
  }


  /* ---------- 5. Show ----------
   * Ein Bildschirm, eine Folie nach der anderen. Das Segment der Folie füllt sich in der eingestellten Zeit,
   * dann kommt die nächste. Finger auf dem Bild hält an, Loslassen läuft weiter. Wer aus dem Bild scrollt,
   * hält die Show an. Nach der letzten Folie bleibt sie stehen (oder beginnt von vorn, im Regler).
   * "Wer da ist" (nur in diesem Browser, nichts geht an uns): beim ersten Besuch kommt die Kampagne mit
   * "Beim ersten Besuch zuerst" an den Anfang, wer wiederkommt, sieht zuerst die zuletzt angetippte,
   * freitags ab 16 Uhr kommt die Kampagne mit "Freitag ab 16 Uhr" dazu und an den Anfang.
   */
  const show = root.querySelector('[data-tl-show]');
  const alleFolien = show ? [...show.querySelectorAll('[data-tl-folie5]')] : [];
  const segBox = show ? show.querySelector('[data-tl-segmente5]') : null;
  // Am Desktop unter der Show: ein Punkt je Folie, die gezeigte ist eine Kapsel, in der die Zeit abläuft, daneben Anhalten
  const steuerung = root.querySelector('[data-tl-steuerung5]');
  const punktBox = steuerung ? steuerung.querySelector('[data-tl-punkte5]') : null;
  const pauseKnopf = steuerung ? steuerung.querySelector('[data-tl-pause5]') : null;
  let angehalten = false;
  let reihe = [];
  let sIdx = 0;
  let sTimer = 0;
  let sRest = 0;
  let sStart = 0;
  let laeuft = false;
  let gehalten = false;
  let fokus = false; /* Fokus mit der Tastatur auf einem Button der Show: Sie wartet, damit die Folie nicht unter dem Fokus wechselt */
  let sichtbar = true;
  /* Ist das Menü am Handy offen, deckt es die Show zu: Sie wartet, die Zeit der Folie läuft danach weiter (zl-kopf.js meldet,
     sobald die Fläche ganz offen ist, und sofort beim Schließen) */
  let menuOffen = false;
  document.addEventListener('zl-menu', (e) => {
    menuOffen = !!(e.detail && e.detail.offen);
    if (show && S.r === '5') showLaufen();
    if (!menuOffen) kopfStellen(); // nach dem Schließen den Kopf frisch nach Lage der Seite stellen
  });
  /* Liegt ein Fenster über der Seite, wartet die Show mit Zeit und Lauf der Auszeichnungen, bis es weg ist (Moritz, 11.10.2026):
     der Hinweis zu Cookies von Shopify (beim ersten Besuch, auch die Einstellungen dazu) und das Fenster zur Anmeldung zum
     Newsletter von Klaviyo. Beim Laden wartet sie höchstens --zl-tl-deckel-warten, ob der Hinweis zu Cookies kommt. Nur lesen:
     Hinweis und Fenster selbst bleiben unberührt. */
  const COOKIE = '#shopify-pc__banner, #shopify-pc__prefs__dialog';
  const sieht = (el) => el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  const cookieOffen = () => [...document.querySelectorAll(COOKIE)].some(sieht);
  /* Fenster von Klaviyo: Nach dem Schließen („Nein, danke“, Kreuz) bleibt seine Hülle im Dokument stehen, sichtbar für den
     Browser, aber leer oder ausgeblendet. Darum zählt nur, was Klaviyo meldet (open bis close), und dazwischen ein Formular,
     das wirklich zu sehen ist; blendet Klaviyo es gerade aus (klaviyo-fadeout), gilt es als zu. Die kleine Leiste unten
     (Teaser) deckt nichts zu und zählt nicht. */
  const opak = (el) => { for (let e = el; e && e !== document.body; e = e.parentElement) { if (getComputedStyle(e).opacity === '0') return false; } return true; };
  const blende = (d, art) => document.getAnimations().some((a) => {
    const z = a.effect && a.effect.target;
    return art.test(a.animationName || '') && a.playState !== 'finished' && z instanceof Element && (z.contains(d) || d.contains(z));
  });
  const klSichtbar = () => [...document.querySelectorAll('[role="dialog"][aria-label="POPUP Form"]')].some((d) => {
    if (!sieht(d) || blende(d, /fadeout/i)) return false;
    const einblenden = blende(d, /fadein/i); // beim Öffnen beginnt das Fenster unsichtbar und blendet ein: das zählt schon als offen
    return [...d.querySelectorAll('form')].some((f) => f.getBoundingClientRect().height > 0 && (einblenden || opak(f)));
  });
  const cookieErwartet = () => {
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.shouldShowBanner !== 'function') return null; // noch nicht geladen
    if (!cp.shouldShowBanner()) return false;
    const c = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() || {} : {};
    return ['analytics', 'marketing', 'preferences'].some((k) => c[k] === ''); // noch nicht entschieden
  };
  let verdeckt = false;
  let deckelStart = !!show; // beim Laden: warten, ob der Hinweis zu Cookies kommt
  const deckelEnde = performance.now() + zeitMs('--zl-tl-deckel-warten');
  let deckelUhr = 0;
  /* Klaviyo meldet das Öffnen, bevor das Fenster steht: ab der Meldung gilt es als offen, bis Klaviyo das Schließen meldet
     oder das Fenster wieder verschwunden ist. Erscheint es nach der Meldung nicht innerhalb von --zl-tl-deckel-warten, gilt es als zu. */
  let klOffen = 0; // Zeitpunkt der Meldung, 0 = zu
  let klGesehen = false;
  function deckelPruefen() {
    clearTimeout(deckelUhr);
    const vorher = verdeckt || deckelStart;
    if (klOffen) {
      if (klSichtbar()) klGesehen = true;
      else if (klGesehen || performance.now() - klOffen > zeitMs('--zl-tl-deckel-warten')) { klOffen = 0; klGesehen = false; }
    }
    verdeckt = cookieOffen() || !!klOffen;
    if (deckelStart && (verdeckt || cookieErwartet() === false || performance.now() > deckelEnde)) deckelStart = false;
    if (show && S.r === '5' && vorher !== (verdeckt || deckelStart)) showLaufen();
    if (verdeckt || deckelStart) deckelUhr = setTimeout(deckelPruefen, zeitMs('--zl-tl-deckel-takt'));
  }
  if (show) {
    window.addEventListener('klaviyoForms', (e) => {
      const typ = e.detail && e.detail.type;
      if (typ === 'open') { klOffen = performance.now(); klGesehen = false; }
      if (typ === 'close') { klOffen = 0; klGesehen = false; }
      setTimeout(deckelPruefen, 0);
    });
    document.addEventListener('visitorConsentCollected', () => setTimeout(deckelPruefen, 0));
    // Der Hinweis zu Cookies hängt sich direkt an body: kommt dort etwas dazu, gleich und kurz danach noch einmal nachsehen
    if (document.body) new MutationObserver(() => { deckelPruefen(); setTimeout(deckelPruefen, zeitMs('--zl-tl-deckel-takt')); }).observe(document.body, { childList: true });
  }
  const BESUCHE = 'zl-start-besuche';
  const ZULETZT = 'zl-start-zuletzt';
  const lies = (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } };
  const schreib = (k, v) => { try { localStorage.setItem(k, v); } catch (e) { /* ohne Speicher geht es auch */ } };
  let besuche = parseInt(lies(BESUCHE) || '0', 10) + 1;
  if (show) schreib(BESUCHE, String(besuche));
  const freitagJetzt = () => { const d = new Date(); return d.getDay() === 5 && d.getHours() >= 16; };

  function showReihe() {
    const m = S.besuch;
    // Die Reihenfolge der Folien ist fest (Moritz, 11.10.2026), Freitag ab 16 Uhr kommt die Feierabend-Kampagne dazu
    const freitag = m === 'freitag' || ((m === 'echt' || m === 'aus') && freitagJetzt());
    const erst = m === 'erst' || (m === 'echt' && besuche <= 1);
    let zuletzt = null;
    if (m === 'wieder') zuletzt = lies(ZULETZT) || (alleFolien[0] && alleFolien[0].dataset.id);
    if (m === 'echt' && !erst) zuletzt = lies(ZULETZT);
    // "Noch nicht": Kampagnen, die erst live gehen, wenn ihr Produkt verfügbar ist, zeigt nur das Labor auf Wunsch
    let liste = alleFolien.filter((f) => (f.dataset.zeit !== 'freitag' || freitag) && (f.dataset.zeit !== 'spaeter' || S.spaeter === 'an'));
    const vorn = (test) => { const i = liste.findIndex(test); if (i > 0) liste.unshift(liste.splice(i, 1)[0]); };
    if (m !== 'aus') {
      if (zuletzt) vorn((f) => f.dataset.id === zuletzt);
      else if (erst) vorn((f) => f.dataset.zuerst === 'true');
      if (freitag) vorn((f) => f.dataset.zeit === 'freitag');
    }
    // Etikett "Zuletzt angesehen" an der Folie, die wiederkommt
    alleFolien.forEach((f) => {
      const e = f.querySelector('[data-tl-etikett]');
      if (!e) return;
      if (e.dataset.orig === undefined) e.dataset.orig = e.textContent;
      // Nicht auf der Folie mit dem großen Siegel: dort ist das Siegel oben, das Etikett würde alles nach unten schieben
      const hier = m !== 'aus' && zuletzt && f.dataset.id === zuletzt && !f.hasAttribute('data-siegel-gross');
      e.textContent = hier ? 'Zuletzt angesehen' : e.dataset.orig;
      e.hidden = !e.textContent.trim();
    });
    alleFolien.forEach((f) => f.classList.toggle('is-weg', !liste.includes(f)));
    reihe = liste;
    // Nur eine Folie (etwa in der Schweiz ohne Probierpaket): keine Zeit, keine Balken, Punkte und Pfeile, die Show steht
    root.toggleAttribute('data-eine-folie', reihe.length < 2);
    if (segBox) {
      segBox.textContent = '';
      reihe.forEach(() => { const sp = document.createElement('span'); sp.append(document.createElement('i')); segBox.append(sp); });
    }
    if (punktBox) {
      punktBox.textContent = '';
      reihe.forEach((f, j) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'zl-tl-steuerung__punkt';
        b.setAttribute('aria-label', 'Folie ' + (j + 1) + ': ' + (f.dataset.name || ''));
        const pip = document.createElement('span');
        pip.className = 'zl-tl-steuerung__pip';
        pip.append(document.createElement('i'));
        b.append(pip);
        b.addEventListener('click', () => showZeigen(j));
        punktBox.append(b);
      });
    }
  }
  /* Wechsel der Show (Moritz, 12.10.2026, Werte nachgemessen): Ein Wechsel ist eine einzige Bewegung. Bild und Schrift
   * hängen an derselben Lage p (0 die gezeigte Folie, 1 die nächste), nicht an zwei Uhren.
   * Bild „gleiten“ (Moritz, 12.10.2026: schöner und eleganter): Beide Folien gleiten um die Breite der Show, die neue kommt
   * aus der Richtung des Wechsels. Bild „blenden“ (im Regler): Die neue Folie liegt oben und kommt mit p, die alte steht darunter voll, nichts scheint durch.
   * Schrift: Jede Folie hat einen Abstand zur gezeigten. Ihre Schrift liegt um Abstand × --zl-tl-text-weg weiter in
   * Richtung des Wechsels und ist ab 1 / --zl-tl-text-sicht unsichtbar: Die alte läuft voraus weg und ist nach knapp einem
   * Drittel verschwunden, die neue holt im letzten Drittel auf und landet auf der Kante.
   * Ohne Finger läuft p in --zl-tl-wechsel-dauer, quadratisch sanft an und aus. Beim Wischen folgt p dem Finger, nach dem
   * Loslassen rollt der Rest in --zl-tl-wechsel-los aus, zu kurz gewischt läuft alles zurück. In Ruhe ist nichts verschoben
   * und nichts trägt eine eigene Ebene. Schläft die Seite (Tab im Hintergrund), stellt eine Uhr das Ende sicher, damit
   * nichts neben der Kante stehen bleibt. Bei reduzierter Bewegung blendet die Show wie vorher. */
  const tx = { alt: null, neu: null, p: 0, d: 1, raf: 0, uhr: 0 };
  const txAn = () => S.textWechsel === 'vor' && !reduced.matches && S.r === '5';
  const gleitet = () => S.bildWechsel === 'gleiten';
  const txWert = (name) => parseFloat(getComputedStyle(html).getPropertyValue(name)) || 0;
  const quadInOut = (t) => (t < 0.5 ? 2 * t * t : 1 - ((-2 * t + 2) ** 2) / 2); // token-ok: quadratisch sanft an und aus
  const kubischAus = (t) => 1 - (1 - t) ** 3; // token-ok: Ausrollen nach dem Loslassen
  function schriftSetzen(f, abstand) {
    const x = abstand * txWert('--zl-tl-text-weg');
    const sicht = Math.max(0, 1 - Math.abs(abstand) * txWert('--zl-tl-text-sicht'));
    f.querySelectorAll(':scope > .zl-tl-text').forEach((el) => {
      el.style.willChange = 'transform, opacity';
      el.style.transform = 'translate3d(' + x.toFixed(1) + 'px, 0, 0)';
      el.style.opacity = sicht.toFixed(3);
    });
  }
  function bildSetzen(f, abstand, oben) {
    f.style.transition = 'none';
    f.style.visibility = 'visible';
    f.style.zIndex = oben ? '2' : '1'; // token-ok: die kommende Folie liegt über der gehenden
    if (gleitet()) {
      f.style.willChange = 'transform';
      f.style.transform = 'translate3d(' + (abstand * (show.clientWidth || 0)).toFixed(1) + 'px, 0, 0)';
      f.style.opacity = '1';
    } else {
      f.style.willChange = 'opacity';
      f.style.removeProperty('transform');
      f.style.opacity = oben ? (1 - Math.abs(abstand)).toFixed(3) : '1';
    }
  }
  // Zurück in Ruhe: erst ohne Übergang in den Endzustand, kurz danach gehören die Werte wieder dem CSS (gleiche Werte, nichts springt)
  function ruhe(f) {
    if (!f) return;
    f.querySelectorAll(':scope > .zl-tl-text').forEach((el) => { el.style.removeProperty('will-change'); el.style.removeProperty('transform'); el.style.removeProperty('opacity'); });
    const da = f.classList.contains('is-aktiv');
    f.style.transition = 'none';
    ['transform', 'will-change', 'z-index'].forEach((k) => f.style.removeProperty(k));
    f.style.opacity = da ? '1' : '0';
    f.style.visibility = da ? 'visible' : 'hidden';
    setTimeout(() => {
      if (f === tx.alt || f === tx.neu) return; // schon im nächsten Wechsel
      ['transition', 'opacity', 'visibility'].forEach((k) => f.style.removeProperty(k));
    }, 60); // token-ok: einen Moment nach dem letzten Bild
  }
  function txStellen(p) {
    tx.p = p;
    const a = -tx.d * p;
    const n = tx.d * (1 - p);
    bildSetzen(tx.alt, a, false);
    bildSetzen(tx.neu, n, true);
    schriftSetzen(tx.alt, a);
    schriftSetzen(tx.neu, n);
  }
  function txEnde() {
    cancelAnimationFrame(tx.raf);
    clearTimeout(tx.uhr);
    const fertig = [tx.alt, tx.neu];
    tx.alt = null;
    tx.neu = null;
    tx.p = 0;
    tx.raf = 0;
    fertig.forEach(ruhe);
  }
  function txLaufen(ziel, dauer, kurve) {
    cancelAnimationFrame(tx.raf);
    clearTimeout(tx.uhr);
    const von = tx.p;
    const t0 = performance.now();
    const schritt = (jetzt) => {
      const t = dauer > 0 ? clamp((jetzt - t0) / dauer, 0, 1) : 1;
      txStellen(von + (ziel - von) * kurve(t));
      if (t < 1) tx.raf = requestAnimationFrame(schritt); else txEnde();
    };
    tx.raf = requestAnimationFrame(schritt);
    tx.uhr = setTimeout(() => { if (tx.alt) { txStellen(ziel); txEnde(); } }, dauer + 250); // token-ok: Sicherung, falls die Seite keine Bilder zeichnet
  }
  function showZeigen(i, vonHand) {
    if (!reihe.length) return;
    clearTimeout(sTimer);
    const altIdx = sIdx;
    const alt = reihe[altIdx];
    const richtung = i < altIdx ? -1 : 1;
    const letzte = reihe.length - 1;
    if (i > letzte) i = S.ende === 'schleife' ? 0 : letzte;
    if (i < 0) i = S.ende === 'schleife' ? letzte : 0;
    sIdx = i;
    const neu = reihe[sIdx];
    if (vonHand && tx.neu === neu) {
      // Vom Finger übernommen: Bild und Schrift rollen in der restlichen Zeit aus
      txLaufen(1, zeitMs('--zl-tl-wechsel-los') * (1 - tx.p), kubischAus);
    } else {
      txEnde();
      if (txAn() && alt && neu && alt !== neu) {
        tx.alt = alt;
        tx.neu = neu;
        tx.d = richtung;
        txStellen(0);
        txLaufen(1, zeitMs('--zl-tl-wechsel-dauer'), quadInOut);
      }
    }
    reihe.forEach((f, j) => f.classList.toggle('is-aktiv', j === sIdx));
    eager(reihe[sIdx]); // falls jemand schneller wischt, als vorgeladen wurde
    nachbarnVorladen();
    const segs = segBox ? [...segBox.children] : [];
    segs.forEach((sp, j) => { sp.classList.toggle('is-fertig', j < sIdx); sp.classList.remove('is-aktiv', 'is-voll'); });
    const akt = segs[sIdx];
    if (akt) { void akt.offsetWidth; akt.classList.add('is-aktiv'); }
    const punkte = punktBox ? [...punktBox.children] : [];
    punkte.forEach((b, j) => { b.classList.remove('is-aktiv', 'is-voll'); b.removeAttribute('aria-current'); });
    const p = punkte[sIdx];
    if (p) { void p.offsetWidth; p.classList.add('is-aktiv'); p.setAttribute('aria-current', 'true'); }
    if (show) delete show.dataset.ende;
    laufStarten(reihe[sIdx]);
    if (kalWartet && neu !== kalFolie) kalWartenEnde('Folie gewechselt, bevor das Modell kam');
    if (kalFolie && reihe[sIdx] === kalFolie) kalAnlass(true);
    segStellen();
    laeuft = false;
    sRest = S.timerS * 1000;
    showLaufen();
    kopfStellen();
  }
  // Segmente und Textlink unten: hell auf dunkler Kante. Oben gilt der Ton hinter dem Text.
  function segStellen() {
    if (!show) return;
    const f = reihe[sIdx];
    if (!f) return;
    const dunkel = S.segmente === 'oben'
      ? f.dataset.ton === 'dunkel' || (f.dataset.lage === 'voll' && (f.dataset.bild === 'b' ? f.dataset.farbeB : f.dataset.farbe) === 'hell')
      : f.dataset.tonUnten === 'dunkel';
    show.dataset.seg = dunkel ? 'hell' : 'dunkel';
  }
  /* Der Balken der laufenden Folie wird bei jedem Losgehen neu gestartet, an der Stelle, an der die Zeit steht (negative
     Verzögerung). Safari am iPhone setzt eine Animation, die angehalten begonnen hat (etwa unter dem Hinweis zu Cookies),
     nach dem Weiterlaufen nicht sichtbar fort: Die Folie wechselte, der Balken blieb leer (Moritz, 11.10.2026). */
  function zeitStellen() {
    const gelaufen = Math.max(0, S.timerS * 1000 - sRest);
    const balken = [segBox && segBox.children[sIdx], punktBox && punktBox.children[sIdx]].filter(Boolean).map((el) => el.querySelector('i')).filter(Boolean);
    balken.forEach((i) => { i.style.animation = 'none'; });
    if (balken.length) void balken[0].offsetWidth;
    balken.forEach((i) => { i.style.animation = ''; i.style.animationDelay = gelaufen ? -gelaufen + 'ms' : ''; });
  }
  function showLaufen() {
    clearTimeout(sTimer);
    // Was von der Zeit dieser Folie schon gelaufen ist, zählt: Anhalten, Halten und Wegscrollen setzen dort fort
    if (laeuft) { sRest = Math.max(0, sRest - (performance.now() - sStart)); laeuft = false; }
    const darf = S.r === '5' && S.lauf === 'an' && reihe.length > 1 && !kalWartet && !reduced.matches && !gehalten && !fokus && !angehalten && sichtbar && !menuOffen && !verdeckt && !deckelStart;
    show.dataset.lauf = S.lauf === 'an' && !reduced.matches ? 'an' : 'aus';
    show.classList.toggle('is-gehalten', !darf && S.lauf === 'an');
    // Warum die Show steht, steht unsichtbar in data-warte an der Show (für die Prüfung im Browser)
    const warum = [kalWartet && 'Kalender', gehalten && 'Finger', fokus && 'Fokus', angehalten && 'Pause', !sichtbar && 'nicht im Bild', menuOffen && 'Menü', verdeckt && (cookieOffen() ? 'Cookies' : 'Newsletter'), deckelStart && 'wartet auf Cookies'].filter(Boolean).join(', ');
    show.dataset.warte = warum;
    pauseZeigen();
    if (!darf) return;
    zeitStellen();
    sStart = performance.now();
    laeuft = true;
    sTimer = setTimeout(() => {
      laeuft = false;
      const letzte = sIdx === reihe.length - 1;
      if (letzte && S.ende !== 'schleife') {
        const akt = segBox && segBox.children[sIdx];
        if (akt) akt.classList.add('is-voll');
        const p = punktBox && punktBox.children[sIdx];
        if (p) p.classList.add('is-voll');
        show.dataset.ende = 'ja';
        pauseZeigen();
        return;
      }
      showZeigen(sIdx + 1);
    }, sRest);
  }
  /* Lauf der Auszeichnungen (Folie Awards): Kommt die Folie, wechseln Siegel, Zahl in der Überschrift und Zeile
   * schnell von Auszeichnung zu Auszeichnung, am Ende landet das große Siegel. Einmal je Besuch der Seite, danach steht
   * gleich das Ende. Finger auf dem Bild und Anhalten halten auch den Lauf an. Bei reduzierter Bewegung steht das Ende. */
  let laufRaf = 0;
  let laufFolie = null;
  let laufFertig = false;
  function laufStellen(f, schritt) {
    const siegel = f.querySelector('[data-tl-lauf-siegel]');
    const zeilen = [...f.querySelectorAll('[data-lauf-zeile]')];
    const name = f.querySelector('.zl-tl-name');
    const namen = name ? [...name.querySelectorAll('[data-lauf-name]')] : [];
    const zaehlen = S.nameWahl === '1' && namen.length >= zeilen.length;
    const laeuft = schritt >= 0;
    if (laeuft) siegel.dataset.zeigt = zeilen[schritt].dataset.typ; else delete siegel.dataset.zeigt;
    // Die Zeile bleibt stehen (Moritz, 11.10.2026: sonst zu schnell und unruhig), es zählen nur Überschrift und Siegel
    if (name) name.classList.toggle('laeuft', laeuft && zaehlen);
    namen.forEach((n, j) => n.classList.toggle('ist-dran', zaehlen && j === schritt));
  }
  function laufStarten(f) {
    clearTimeout(laufRaf);
    if (laufFolie && laufFolie !== f) laufStellen(laufFolie, -1);
    laufFolie = null;
    if (!f || !f.querySelector('[data-tl-lauf-siegel]')) return;
    const n = f.querySelectorAll('[data-lauf-zeile]').length;
    const siegel = f.querySelector('[data-tl-lauf-siegel]');
    siegel.classList.remove('ist-gelandet');
    if (laufFertig || reduced.matches || !n || S.lauf !== 'an') { laufStellen(f, -1); return; }
    laufFolie = f;
    // Zeit aus zl-tokens.css mit Einheit lesen: Shopify verkleinert die CSS-Datei und schreibt 380ms dabei als .38s
    const roh = getComputedStyle(root).getPropertyValue('--zl-tl-lauf-schritt').trim();
    const schrittMs = (/\ds$/.test(roh) && !/ms$/.test(roh) ? parseFloat(roh) * 1000 : parseFloat(roh)) || 380; // token-ok: Ersatz, falls der Token fehlt
    // Schritt für Schritt mit der Uhr: Gehalten, angehalten oder aus dem Bild wartet der Lauf und zählt nicht weiter
    let s = 0;
    laufStellen(f, 0);
    const weiter = () => {
      if (gehalten || angehalten || !sichtbar || menuOffen || verdeckt || deckelStart) { laufRaf = setTimeout(weiter, schrittMs / 4); return; }
      s += 1;
      if (s >= n) {
        laufStellen(f, -1);
        void siegel.offsetWidth;
        siegel.classList.add('ist-gelandet');
        laufFertig = true;
        laufFolie = null;
        return;
      }
      laufStellen(f, s);
      laufRaf = setTimeout(weiter, schrittMs);
    };
    laufRaf = setTimeout(weiter, schrittMs);
  }
  /* Adventskalender als Modell (Einstellung "Freisteller als Modell"): lädt erst, wenn die Seite steht, und legt sich genau über das
   * Bild. Kommt die Folie, senkt er sich auf seinen Platz und ein Türchen geht einen Spalt auf, einmal je Besuch, danach steht er.
   * Wird das Modell fertig, während die Folie schon zu sehen ist, wechselt es unsichtbar vom Bild und spielt nur das Türchen.
   * Bei reduzierter Bewegung, ohne WebGL oder bei einem Fehler bleibt das Bild. */
  const kalHuelle = show ? show.querySelector('[data-tl-3d]') : null;
  const kalFolie = kalHuelle ? kalHuelle.closest('[data-tl-folie5]') : null;
  const KAL_RAND = 0.2; // token-ok: die Fläche ist rundum um diesen Anteil größer als das Bild, Platz für Schatten und Senken
  let kal = null;
  let kalFl = null;
  let kalGespielt = false;
  /* Schweres kommt nach (CLAUDE.md, Fall 2b): Der Kalender senkt sich auf leere Fläche, sein erstes Bild ist die leere Fläche.
     Kommt die Folie, bevor das Modell bereit ist, wartet sie: Die Fläche bleibt leer, die Zeit der Folie läuft nicht. Ist das
     Modell da, senkt er sich, und die Zeit läuft. Höchstens bis --zl-a-ersatz-daten nach dem Aufruf, danach steht das Bild
     (der Kalender in Ruhe), und das Modell blendet später nur noch weich darüber ein. */
  let kalWartet = false;
  let kalFrist = 0;
  let kalFehler = false;
  /* Prüfanzeige für das Gerät: ?zl-tl-kal=zeigen zeigt oben links, wann was passiert ist */
  const kalAnzeige = /[?&]zl-tl-kal=zeigen/.test(location.search) ? document.createElement('ol') : null;
  if (kalAnzeige) { kalAnzeige.className = 'zl-tl-pruef'; document.body.append(kalAnzeige); }
  function kalLog(text) {
    if (!kalAnzeige) return;
    const li = document.createElement('li');
    li.textContent = (performance.now() / 1000).toFixed(2) + ' s ' + text; // token-ok: Millisekunden in Sekunden
    kalAnzeige.append(li);
  }
  if (kalAnzeige) kalLog(navigator.userAgent.replace(/^Mozilla\/5\.0 /, ''));
  function kalWartenEnde(grund) {
    if (!kalWartet) return;
    kalWartet = false;
    clearTimeout(kalFrist);
    kalHuelle.classList.remove('ist-wartet');
    kalLog(grund);
    showLaufen();
  }
  function kalWarten() {
    const frist = zeitMs('--zl-a-ersatz-daten') - performance.now();
    if (!kalFl || kalFehler || frist <= 0) { kalLog('Folie kommt, Modell nicht bereit: Bild'); return; }
    kalWartet = true;
    kalHuelle.classList.add('ist-wartet');
    kalLog('Folie kommt, wartet auf das Modell');
    kalFrist = setTimeout(() => kalWartenEnde('Frist vorbei: Bild'), frist);
  }
  function kalPlatz() {
    if (!kal || !kalFl) return;
    const img = kalHuelle.querySelector('img');
    const hb = kalHuelle.getBoundingClientRect(), bb = img.getBoundingClientRect();
    const nw = img.naturalWidth || 1100, nh = img.naturalHeight || 931; // token-ok: Größe des Bilds
    const sk = Math.min(bb.width / nw, bb.height / nh);
    const w = Math.round(nw * sk), h = Math.round(nh * sk);
    if (w < 2 || h < 2) return;
    const x = bb.left - hb.left + (bb.width - w) / 2, y = bb.top - hb.top + (bb.height - h) / 2;
    const rx = Math.round(w * KAL_RAND), ry = Math.round(h * KAL_RAND);
    Object.assign(kalFl.style, { left: Math.round(x) - rx + 'px', top: Math.round(y) - ry + 'px', width: w + 2 * rx + 'px', height: h + 2 * ry + 'px' });
    kal.groesse(w + 2 * rx, h + 2 * ry);
  }
  function kalAnlass(kommt) {
    if (!kal) { if (kommt) kalWarten(); return; }
    if (kalWartet) { kommt = true; kalWartenEnde('Modell bereit, senkt sich'); } else if (kommt) kalLog(kalGespielt ? 'Folie kommt, Modell steht' : 'Folie kommt, senkt sich');
    if (kommt) {
      kalFl.style.transition = 'none';
      kalHuelle.classList.add('ist-3d');
      if (kalGespielt) { kalFl.style.opacity = '1'; kal.ruhe(); return; }
      kalGespielt = true;
      kal.abspielen(0);
      return;
    }
    /* Das Bild steht schon: das Modell blendet weich darüber ein, erst danach tritt das Bild zurück. Kein Sprung. */
    kalLog('Modell blendet über dem Bild ein');
    kalGespielt = true;
    kal.ruhe();
    kalFl.style.opacity = '0';
    void kalFl.offsetWidth;
    kalFl.style.transition = 'opacity var(--zl-react-out) var(--zl-ease-react)';
    kalFl.style.opacity = '1';
    setTimeout(() => { kalHuelle.classList.add('ist-3d'); kal.abspielen(kal.gelandet); }, 400); // token-ok: nach dem Einblenden
  }
  /* Schweres im ersten Bildschirm (CLAUDE.md): Entschieden wird nach dem Netz. Gemessen an den schon geladenen Dateien ab 50 kB,
     Bytes durch Ladezeit, der beste Wert zählt. Langsam heißt: das Modell lädt gar nicht, das Bild bleibt. Ohne Messwert gilt schnell. */
  function netzLangsam() {
    try {
      const grenze = parseFloat(getComputedStyle(html).getPropertyValue('--zl-a-netz-schnell')) || 5; // token-ok: Ersatz, falls der Token fehlt (Mbit/s)
      let best = 0;
      performance.getEntriesByType('resource').forEach((e) => {
        if (e.transferSize > 50000 && e.responseStart > 0 && e.responseEnd > e.responseStart) { // token-ok: ab 50 kB misst eine Datei das Netz
          best = Math.max(best, (e.transferSize * 8) / ((e.responseEnd - e.responseStart) / 1000) / 1e6); // token-ok: Bytes je Sekunde in Mbit/s
        }
      });
      return best > 0 && best < grenze;
    } catch (e) { return false; }
  }
  function kalLaden() {
    if (!kalHuelle || kalFl || reduced.matches || S.r !== '5' || kalFolie.classList.contains('is-weg')) { if (kalHuelle && reduced.matches) kalLog('Reduzierte Bewegung: Bild'); return; }
    if (netzLangsam()) { kalLog('Netz langsam: Bild'); return; }
    kalLog('Modell lädt');
    kalFl = document.createElement('canvas');
    kalFl.className = 'zl-tl-3d';
    kalFl.setAttribute('aria-hidden', 'true');
    kalHuelle.append(kalFl);
    const d = kalHuelle.dataset;
    import(kalHuelle.getAttribute('data-tl-3d'))
      .then((m) => m.starten({ flaeche: kalFl, glb: d.glb, hdr: d.hdr, schatten: d.schatten, inhalt: [0, 0, 1, 1], rand: KAL_RAND, tuer: 3 }))
      .then((k) => { kal = k; window.zlKalender = k; kalPlatz(); kalLog('Modell bereit'); if (kalFolie.classList.contains('is-aktiv')) kalAnlass(kalWartet); })
      .catch((e) => { kalFehler = true; if (kalFl) kalFl.remove(); kalFl = null; kalHuelle.classList.remove('ist-3d'); kalLog('Fehler: ' + (e && e.message)); kalWartenEnde('Bild nach Fehler'); console.warn('Kalender als Modell nicht geladen', e); });
  }
  if (kalHuelle) {
    const nachLaden = () => setTimeout(kalLaden, 600); // token-ok: kurz nachdem die Seite steht
    if (document.readyState === 'complete') nachLaden(); else window.addEventListener('load', nachLaden);
    window.addEventListener('resize', kalPlatz);
  }
  // Anhalten zeigt Pause, angehalten und am Ende zeigt Abspielen. Am Ende beginnt Abspielen von vorn.
  function pauseZeigen() {
    if (!pauseKnopf) return;
    const spielt = !angehalten && show.dataset.ende !== 'ja';
    pauseKnopf.dataset.zustand = spielt ? 'spielt' : 'steht';
    pauseKnopf.setAttribute('aria-label', spielt ? 'Anhalten' : (show.dataset.ende === 'ja' ? 'Noch einmal abspielen' : 'Abspielen'));
  }
  function showHalten(an) {
    if (an === gehalten) return;
    gehalten = an;
    showLaufen();
  }
  function showStellen() {
    if (!show) return;
    show.dataset.knopf = S.knopf;
    show.dataset.segmente = S.segmente;
    show.dataset.steuerung = S.steuerung;
    show.dataset.paket = S.paket;
    show.dataset.wheatAuftritt = S.wheatAuftritt;
    glasStellen();
    show.dataset.geschenke = S.geschenke;
    showReihe();
    showZeigen(0);
  }
  // Bilder der späteren Folien laden, sobald die Seite steht, damit beim Wechsel nichts nachlädt
  /* Bilder vorladen, verteilt statt auf einmal (Moritz, 11.10.2026, gemessen am iPhone): Alle Folien auf
   * einmal waren rund 70 Bilder, darunter große Fotos und Freisteller; Laden und Entpacken ließen die Seite in den ersten
   * Sekunden mehrfach 200 bis 750 ms stillstehen, mitten im Lauf der Auszeichnungen und beim Öffnen des Menüs.
   * Jetzt lädt die Show nach dem Laden der Seite nur die Bilder der nächsten und der vorigen Folie vor, bei jedem Wechsel
   * dann wieder die Nachbarn der neuen Folie, jeweils --zl-tl-vorladen nach dem Wechsel, wenn das Überblenden vorbei ist.
   * Bilder außerhalb der Folien kommen wie bisher kurz nach dem Laden. */
  let seiteGeladen = document.readyState === 'complete';
  let vorladenTimer = 0;
  /* Nur Bilder, die gezeichnet werden: Fassungen, die die Folie nicht zeigt (display: none), laden nicht mit */
  const gezeigt = (i) => i.getClientRects().length > 0;
  const eager = (el) => { if (el) el.querySelectorAll('img[loading="lazy"]').forEach((i) => { if (gezeigt(i)) i.loading = 'eager'; }); };
  const nachbarnVorladen = () => {
    clearTimeout(vorladenTimer);
    if (!seiteGeladen || !reihe.length) return;
    vorladenTimer = setTimeout(() => {
      const n = reihe.length;
      eager(reihe[(sIdx + 1) % n]);
      eager(reihe[(sIdx - 1 + n) % n]);
    }, zeitMs('--zl-tl-vorladen'));
  };
  const restVorladen = () => {
    seiteGeladen = true;
    if (show) show.querySelectorAll('img[loading="lazy"]').forEach((i) => { if (!i.closest('[data-tl-folie5]') && gezeigt(i)) i.loading = 'eager'; });
    nachbarnVorladen();
  };
  if (document.readyState === 'complete') setTimeout(restVorladen, 300);
  else window.addEventListener('load', () => setTimeout(restVorladen, 300));
  if (show) {
    /* Antippen der Folie führt zur Kampagne (Moritz, 11.10.2026), weiter und zurück geht mit Wischen und den Punkten.
       Wer lange drückt, um anzuhalten, und loslässt, bleibt auf der Seite. */
    let druckAb = 0;
    show.addEventListener('pointerdown', () => { druckAb = performance.now(); });
    const zurKampagne = () => {
      if (performance.now() - druckAb > 350) return; // token-ok: länger gedrückt heißt anhalten, nicht öffnen
      const f = reihe[sIdx];
      const a = f && f.querySelector('a.zl-tl-btn[href]');
      if (a) { schreib(ZULETZT, f.dataset.id); window.location.href = a.href; }
    };
    show.querySelectorAll('[data-tl-weiter5], [data-tl-zurueck5]').forEach((b) => {
      b.setAttribute('aria-hidden', 'true');
      b.tabIndex = -1;
      b.addEventListener('click', zurKampagne);
    });
    if (pauseKnopf) {
      pauseKnopf.addEventListener('click', () => {
        if (show.dataset.ende === 'ja') { angehalten = false; showZeigen(0); return; }
        angehalten = !angehalten;
        showLaufen();
      });
    }
    show.addEventListener('pointerdown', (e) => { if (!e.target.closest('a')) showHalten(true); });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach((t) => show.addEventListener(t, () => showHalten(false)));
    // Erscheint während des Haltens etwas über der Show, endet der Finger dort: auch dann loslassen
    ['pointerup', 'pointercancel', 'touchend', 'touchcancel', 'blur'].forEach((t) => window.addEventListener(t, () => showHalten(false), { passive: true }));
    let sx = 0;
    let sy = 0;
    let achse = ''; // '' noch offen, 'x' Wischen zur Seite, 'y' Scrollen der Seite
    show.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; achse = ''; }, { passive: true });
    // Wischen zur Seite: Bild und Schrift folgen dem Finger (Text beim Wechsel)
    show.addEventListener('touchmove', (e) => {
      if (!txAn() || reihe.length < 2) return;
      const dx = e.touches[0].clientX - sx;
      const dy = e.touches[0].clientY - sy;
      if (!achse) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return; // token-ok: erst ab einem kleinen Weg entscheidet sich die Richtung
        achse = Math.abs(dx) > Math.abs(dy) * 1.5 ? 'x' : 'y';
      }
      if (achse !== 'x') return;
      const d = dx < 0 ? 1 : -1;
      const n = reihe.length;
      const j = sIdx + d;
      if (S.ende !== 'schleife' && (j < 0 || j > n - 1)) return;
      const ziel = reihe[(j + n) % n];
      if (tx.neu !== ziel || tx.alt !== reihe[sIdx]) {
        txEnde();
        tx.alt = reihe[sIdx];
        tx.neu = ziel;
        tx.d = d;
        eager(ziel);
      }
      cancelAnimationFrame(tx.raf);
      clearTimeout(tx.uhr);
      txStellen(clamp(Math.abs(dx) / (show.clientWidth || 1), 0, 1));
    }, { passive: true });
    const zurueck = () => txLaufen(0, zeitMs('--zl-tl-wechsel-los') * tx.p, kubischAus); // zu kurz gewischt: alles an seinen Platz
    show.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - sx;
      const dy = e.changedTouches[0].clientY - sy;
      const gezogen = achse === 'x' && !!tx.neu;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) { showZeigen(sIdx + (dx < 0 ? 1 : -1), gezogen); return; }
      if (gezogen) zurueck();
    }, { passive: true });
    show.addEventListener('touchcancel', () => { if (achse === 'x' && tx.neu) zurueck(); }, { passive: true });
    // Wer eine Kampagne antippt, sieht sie beim nächsten Besuch zuerst
    alleFolien.forEach((f) => f.addEventListener('click', (e) => { if (e.target.closest('a')) schreib(ZULETZT, f.dataset.id); }));
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => { sichtbar = e.isIntersecting; if (S.r === '5') showLaufen(); }, { threshold: 0.35 }).observe(show);
    }
  }

  /* ---------- 6. Ein Satz: die Zeile unten wechselt nach Zeit, Antippen führt zur Kampagne ---------- */
  const ticker = root.querySelector('[data-tl-ticker]');
  const tEintraege = ticker ? [...ticker.children] : [];
  let tIdx = 0;
  let tTimer = 0;
  function tickerStellen() {
    clearTimeout(tTimer);
    if (!ticker || !tEintraege.length) return;
    tEintraege.forEach((e, j) => e.classList.toggle('is-aktiv', j === tIdx));
    const satz = root.querySelector('.zl-tl-satz [data-tl-k]');
    const box = root.querySelector('.zl-tl-satz');
    if (satz && box) box.dataset.ton = satz.dataset.ton || 'hell';
    if (S.r !== '6' || S.tickerLauf !== 'an' || reduced.matches || tEintraege.length < 2) return;
    tTimer = setTimeout(() => { tIdx = (tIdx + 1) % tEintraege.length; tickerStellen(); }, S.timerS * 1000);
  }

  /* ---------- Darunter (nur auf ?view=zl-start) ----------
   * Die Richtung und die Texte darunter wählt derselbe Regler. Die Sektion darunter liest html[data-zl-du]
   * und zeigt in jeder Gruppe mit data-zl-wahl nur das Kind mit der gewählten Nummer.
   */
  function wahlStellen() {
    const wahl = { haltung: S.haltung, sorten: S.sortenTitel, paket: S.paketTitel, name: S.nameWahl, 'zeile-awards': S.zeileWahl, 'zeile-advent': S.adventZeile };
    document.querySelectorAll('[data-zl-wahl]').forEach((g) => {
      const kinder = [...g.children].filter((c) => c.dataset.wahl !== undefined);
      const w = kinder.some((c) => c.dataset.wahl === wahl[g.dataset.zlWahl]) ? wahl[g.dataset.zlWahl] : '1';
      kinder.forEach((c) => { c.hidden = c.dataset.wahl !== w; });
    });
  }
  function darunterStellen() {
    wahlStellen();
    if (!darunterDa) return;
    html.dataset.zlDu = S.darunter;
    html.dataset.zlDuKauf = S.kauf;
    html.dataset.zlDuBekannt = S.bekannt;
    html.dataset.zlDuZucker = S.zucker0;
    html.style.setProperty('--du-licht', S.licht);
    html.style.setProperty('--du-dunkel', S.dunkel);
    document.dispatchEvent(new CustomEvent('zl:darunter'));
  }

  /* ---------- Regler ---------- */
  const feld = document.querySelector('[data-tl-regler]');
  const knopf = document.querySelector('[data-tl-knopf]');
  function anzeige(f, v) {
    if (f.stufen) for (const [w, t] of f.stufen) if (Number(v) === w) return t;
    if (f.prozent) return Math.round(v * 100) + ' %';
    return String(v).replace('.', ',') + (f.einheit || '');
  }
  function richtungenBauen() {
    const h = document.createElement('h2');
    h.textContent = 'Richtung';
    feld.append(h);
    const reihe = document.createElement('div');
    reihe.className = 'zl-tl-richtungen';
    for (let i = 1; i <= 6; i++) {
      const b = document.createElement('button');
      b.type = 'button';
      b.textContent = i;
      b.setAttribute('aria-label', 'Richtung ' + i + ': ' + NAMEN[i]);
      b.setAttribute('aria-pressed', String(S.r === String(i)));
      b.addEventListener('click', () => {
        S.r = String(i);
        save();
        window.scrollTo({ top: 0 });
        apply();
        baueRegler();
      });
      reihe.append(b);
    }
    feld.append(reihe);
    const name = document.createElement('p');
    name.className = 'zl-tl-hinweis';
    name.textContent = S.r + '. ' + NAMEN[S.r];
    feld.append(name);
  }
  const BILDER = [['a', 'A Foto'], ['b', 'B Foto'], ['c', 'C Ganz nah'], ['e', 'E Ganze Flasche'], ['d', 'D Ausstellung'], ['g', 'G Grafik']];
  function bildJeFolieBauen() {
    alleFolien.forEach((f) => {
      const z = document.createElement('label');
      z.className = 'zl-tl-zeile-r';
      const t = document.createElement('span');
      t.textContent = 'Bild: ' + (f.dataset.name || f.dataset.id);
      const sel = document.createElement('select');
      const std = desktop.matches && f.dataset.showBildD ? f.dataset.showBildD : f.dataset.showBild;
      BILDER.filter(([w]) => w !== 'g' || f.querySelector('.zl-tl-bild__g')).forEach(([w, txt]) => {
        const o = document.createElement('option');
        o.value = w;
        o.textContent = txt + (w === std ? ' (Standard)' : '');
        if ((S.fb[f.dataset.id] || std) === w) o.selected = true;
        sel.append(o);
      });
      sel.addEventListener('change', () => {
        if (sel.value === std) delete S.fb[f.dataset.id]; else S.fb[f.dataset.id] = sel.value;
        save();
        apply();
      });
      z.append(t, sel);
      feld.append(z);
    });
  }
  function baueRegler() {
    feld.textContent = '';
    if (!nurShow) richtungenBauen();
    for (const f of [...FELDER[S.r], ...(nurShow ? [] : FELDER.alle), ...(darunterDa ? FELDER.darunter : [])]) {
      if (f.nur && !f.nur.includes(S.r)) continue;
      if (f.nurStart && !nurShow) continue;
      if (f.nur_du && !f.nur_du.includes(S.darunter)) continue;
      if (f.gruppe) { const g = document.createElement('h2'); g.textContent = f.gruppe; feld.append(g); continue; }
      if (f.bildJeFolie) { bildJeFolieBauen(); continue; }
      if (f.hinweis) { const p = document.createElement('p'); p.className = 'zl-tl-hinweis'; p.textContent = f.hinweis; feld.append(p); continue; }
      const z = document.createElement('label');
      z.className = 'zl-tl-zeile-r';
      const t = document.createElement('span');
      t.textContent = f.label;
      z.append(t);
      if (f.typ === 'wahl') {
        const sel = document.createElement('select');
        for (const [w, txt] of f.optionen) {
          const o = document.createElement('option');
          o.value = w;
          o.textContent = txt;
          if (String(S[f.key]) === w) o.selected = true;
          sel.append(o);
        }
        sel.addEventListener('change', () => { S[f.key] = sel.value; save(); apply(); if (f.key === 'darunter') baueRegler(); });
        z.append(sel);
      } else {
        const out = document.createElement('output');
        const r = document.createElement('input');
        r.type = 'range';
        r.min = f.min; r.max = f.max; r.step = f.step;
        r.value = S[f.key];
        out.textContent = anzeige(f, S[f.key]);
        r.addEventListener('input', () => { S[f.key] = Number(r.value); out.textContent = anzeige(f, S[f.key]); save(); apply(); });
        z.append(out, r);
      }
      feld.append(z);
    }
    const akt = document.createElement('div');
    akt.className = 'zl-tl-richtungen';
    const kopie = document.createElement('button');
    kopie.type = 'button';
    kopie.textContent = 'Werte kopieren';
    kopie.style.gridColumn = '1 / -1';
    kopie.addEventListener('click', async () => {
      const text = 'Labor Teaser, Richtung ' + S.r + ' (' + NAMEN[S.r] + '): ' + JSON.stringify(S);
      try { await navigator.clipboard.writeText(text); kopie.textContent = 'Kopiert'; } catch (e) { window.prompt('Werte', text); }
      setTimeout(() => { kopie.textContent = 'Werte kopieren'; }, 1500);
    });
    const linkKnopf = document.createElement('button');
    linkKnopf.type = 'button';
    linkKnopf.textContent = 'Link kopieren';
    linkKnopf.style.gridColumn = '1 / -1';
    linkKnopf.addEventListener('click', async () => {
      save();
      const text = location.href;
      try { await navigator.clipboard.writeText(text); linkKnopf.textContent = 'Kopiert'; } catch (e) { window.prompt('Link', text); }
      setTimeout(() => { linkKnopf.textContent = 'Link kopieren'; }, 1500);
    });
    akt.append(kopie, linkKnopf);
    feld.append(document.createElement('h2'), akt);
  }
  // Regler ans Ende der Seite, damit er über allem liegt und nicht in der Ebene der Sektion
  if (knopf) document.body.append(knopf);
  if (feld) document.body.append(feld);
  if (knopf && feld) {
    knopf.addEventListener('click', () => {
      const offen = feld.hidden;
      feld.hidden = !offen;
      knopf.setAttribute('aria-expanded', String(offen));
      if (offen) baueRegler();
    });
  }

  if (show) {
    /* Nur ein Fokus aus der Tastatur hält die Show an. Setzt ein Skript den Fokus (etwa Klaviyo oder der Hinweis zu Cookies
       beim Schließen), gilt das im Browser ebenfalls als Fokus, die Show liefe sonst nie weiter (Moritz, 11.10.2026). */
    let perTaste = false;
    window.addEventListener('keydown', (e) => { if (e.key === 'Tab' || e.key === 'Enter' || e.key === ' ' || e.key.startsWith('Arrow')) perTaste = true; }, true);
    ['pointerdown', 'touchstart'].forEach((t) => window.addEventListener(t, () => { perTaste = false; }, { capture: true, passive: true }));
    show.addEventListener('focusin', () => { if (!perTaste) return; fokus = true; showLaufen(); });
    show.addEventListener('focusout', (e) => { if (show.contains(e.relatedTarget)) return; if (fokus) { fokus = false; showLaufen(); } });
  }
  window.addEventListener('scroll', () => requestAnimationFrame(kopfStellen), { passive: true });
  window.addEventListener('resize', () => { kopfMessen(); lageStellen(); buehneFit(); buehneTiefe(); });
  /* Die Kästen der Produkte ändern ihre Größe nach dem Fenster (Bühne, Kalender): danach Spalte und Name neu, dann die Kante */
  if (window.ResizeObserver) {
    let spaltenRuhe = 0, spaltenZeit = 0, spaltenRunden = 0;
    const neuSpalten = new ResizeObserver(() => { clearTimeout(spaltenRuhe); spaltenRuhe = setTimeout(() => { const jetzt = Date.now(); if (jetzt - spaltenZeit > 1000) spaltenRunden = 0; spaltenZeit = jetzt; if (++spaltenRunden > 3) return; lageStellen(); }, 100); /* token-ok: höchstens drei Runden je Sekunde, dann steht alles */ }); // token-ok: kurz warten, bis die Größe steht
    root.querySelectorAll('.zl-tl-folie5 .zl-tl-nah, .zl-tl-folie5 .zl-tl-bild').forEach((el) => neuSpalten.observe(el));
  }
  // Bilder der Show kommen nach und nach: mit ihrer Größe steht fest, wo das Produkt beginnt
  root.querySelectorAll('.zl-tl-folie5 .zl-tl-bild img, .zl-tl-folie5 .zl-tl-nah img').forEach((i) => { if (!i.complete) i.addEventListener('load', () => textSpalten(), { once: true }); });
  window.addEventListener('load', () => { textSpalten(); produktStellen(); });
  root.querySelectorAll('.zl-tl-folie5 .zl-tl-bild__g').forEach((i) => i.addEventListener('load', () => produktStellen()));
  window.addEventListener('hashchange', () => {
    if (live || nurShow || !window.zlStand) return;
    const neu = window.zlStand.lesen(START);
    if (neu.r && !/^[1-6]$/.test(neu.r)) delete neu.r;
    const anders = Object.keys(neu).some((k) => String(neu[k]) !== String(S[k]));
    if (!anders) return;
    Object.assign(S, neu);
    save(); apply(); if (feld && !feld.hidden) baueRegler();
  });
  /* Gemessen wird erst mit beiden Schnitten der Schrift. document.fonts.status ist schon 'loaded', bevor eine Schrift
     überhaupt angefragt ist, deshalb werden beide Schnitte ausdrücklich geladen. Kommt die Schrift nicht rechtzeitig,
     gilt nach --zl-tl-schrift-warten die Ersatzschrift, damit nichts unsichtbar bleibt. */
  if (document.fonts && document.fonts.load) {
    const familie = '"halfourgroteskzerolabs-regular-webfont"';
    const fertig = () => { schriftDa = true; lageStellen(); buehneFit(); }; /* auch nach Ablauf der Wartezeit: kommt die Schrift später, wird neu gemessen */
    Promise.all([document.fonts.load('400 1em ' + familie), document.fonts.load('500 1em ' + familie)]).then(fertig, fertig); // token-ok: Gewicht und Größe nur, um den Schnitt anzufragen
    const roh = getComputedStyle(html).getPropertyValue('--zl-tl-schrift-warten').trim();
    setTimeout(fertig, (/\ds$/.test(roh) && !/ms$/.test(roh) ? parseFloat(roh) * 1000 : parseFloat(roh)) || 0); // Shopify schreibt 1500ms als 1.5s
  } else schriftDa = true;
  kopfMessen();
  apply();
  if (show) deckelPruefen(); // erst jetzt, wenn die Show steht: wartet sie auf den Hinweis zu Cookies oder läuft los
})();
